<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-3 p-ml-3 p-mr-3 p-mb-1" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="fs_tname" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.fs_tname }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <template>
                        <div class="p-col p-mt-3 p-ml-3">
                            <div class="p-grid p-col p-mt-1">
                                <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                    <label for="fullname">{{ $t('information_voulunteer_fullname') }}</label>
                                    <InputText
                                        id="volunteer_fullname"
                                        type="text"
                                        v-model="searchCriteria.volunteer_fullname"
                                        ref="TextBox_2_search"
                                        @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    />
                                </div>

                                <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                    <label for="volunteer_level_id">{{ $t('สถานะการปฏิบัติงาน') }}</label>
                                    <Dropdown
                                        v-model="searchCriteria.workStatus_search"
                                        :options="workStatusOptions"
                                        optionLabel="system_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        inputStyle="color: red;"
                                        :class="{
                                            'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                        }"
                                    >
                                        <template #value="workingStatus">
                                            <div v-if="workingStatus.value">
                                                <div>{{ workingStatus.value.system_name }}</div>
                                            </div>
                                            <span v-else>
                                                {{ workingStatus.placeholder }}
                                            </span>
                                        </template>
                                        <template #option="workingStatus">
                                            <div>{{ workingStatus.option.system_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>
                            </div>

                            <div class="p-grid p-col p-mt-1">
                                <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                    <label for="volunteer_professional">{{ $t('information_voulunteer_speacialist') }}</label>
                                    <Dropdown
                                        v-model="searchCriteria.volunteerProfessional_search"
                                        :options="volunteerProfessionalOptions"
                                        optionLabel="system_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        inputStyle="color: red;"
                                        :class="{
                                            'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                        }"
                                    >
                                        <template #value="professionalOptions">
                                            <div v-if="professionalOptions.value">
                                                <div>{{ professionalOptions.value.system_name }}</div>
                                            </div>
                                            <span v-else>
                                                {{ professionalOptions.placeholder }}
                                            </span>
                                        </template>
                                        <template #option="professionalOptions">
                                            <div>{{ professionalOptions.option.system_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>

                                <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                    <label for="training_history">{{ $t('สังกัดหน่วย/ฐานปฏิบัติ') }}</label>
                                    <Dropdown
                                        v-model="searchCriteria.baseOperation_search"
                                        :options="baseOperationOptions"
                                        optionLabel="system_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        inputStyle="color: red;"
                                        :class="{
                                            'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                        }"
                                    >
                                        <template #value="baseOperationOption">
                                            <div v-if="baseOperationOption.value">
                                                <div>{{ baseOperationOption.value.system_name }}</div>
                                            </div>
                                            <span v-else>
                                                {{ baseOperationOption.placeholder }}
                                            </span>
                                        </template>
                                        <template #option="baseOperationOption">
                                            <div>{{ baseOperationOption.option.system_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>
                            </div>

                            <div class="p-field p-col">
                                <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                    <Button
                                        v-if="window.width <= 430"
                                        @click="MobileClearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                    <Button
                                        v-else
                                        @click="clearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />

                                    <div>
                                        <Button
                                            @click="searchManInfo()"
                                            :label="$t('searchBtn')"
                                            class="p-button-info"
                                            ref="TextBox_4_search"
                                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="manInfo_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('VolunteerModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>
        <!--Data Table Fetching-->
        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? manInfo_Table : []"
                :paginator="true"
                :rows="10"
                scrollHeight="500px"
                dataKey="volunteer_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลอาสาสมัครในพื้นที่กรุงเทพมหานคร-${date}`"
                :rowHover="true"
                :selection.sync="selectedManInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="openModal" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportExcel()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <Button
                                label="ส่งออก PDF"
                                @click="generatePDF()"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></Button>
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedManInfo && selectedManInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe : PDF 1/3 จบ -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->
                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedManInfo.length === manInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedManInfo.some((item) => item.volunteer_id === slotProps.data.volunteer_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.system_id }}</div>
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                    <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_img == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('18rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img == true">
                                <div v-if="dataTable.data.volunteer_image !== '' && dataTable.data.volunteer_image !== null && columns_img == true">
                                    <img
                                        :src="`${dataTable.data.volunteer_image}`"
                                        @click="showImage(dataTable.data.volunteer_image)"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_volunteer_fullname == true">
                    <Column
                        field="volunteer_fullname"
                        :header="'ชื่อ-นามสกุล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_volunteer_fullname == true">
                                {{ dataTable.data.volunteer_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_base_operation == true">
                    <Column
                        field="base_operation"
                        :header="$t('สังกัดหน่วย/ฐานปฏิบัติ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_base_operation == true">
                                <div v-if="dataTable.data.base_operation == null || dataTable.data.base_operation == ''">-</div>
                                <div v-else-if="dataTable.data.base_operation === 'อื่นๆ'">{{ dataTable.data.other_base_operation }}</div>
                                <div v-else>{{ dataTable.data.base_operation }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_volunteer_sex == true">
                    <Column field="volunteer_sex" :header="$t('เพศ')" :sortable="true" :headerStyle="tableColSticky('200px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_volunteer_sex == true">
                                {{ dataTable.data.volunteer_sex }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <Column field="birth_date" :header="'วัน/เดือน/ปี เกิด'" :sortable="true" :headerStyle="tableColSticky('250px', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        {{ formatThaiDate(dataTable.data.birth_date) }}
                    </template>
                </Column>

                <Column
                    field="volunteer_tel"
                    :header="'หมายเลขโทรศัพท์ติดต่อ'"
                    :class="{ 'p-invalid': error_contact_phone && !contact_phone }"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.volunteer_tel }}
                    </template>
                </Column>

                <div v-if="columns_work_status == true">
                    <Column
                        field="work_status"
                        :header="$t('สถานะการปฏิบัติงาน')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_work_status == true">
                                <div v-if="dataTable.data.work_status == null" class="table_row">-</div>
                                <div v-else class="table_row">{{ dataTable.data.work_status }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_specialist_id == true">
                    <Column
                        field="specialist_id"
                        :header="$t('ความเชี่ยวชาญ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_specialist_id == true">
                                <div v-if="dataTable.data.volunteer_professional === 'อื่นๆ'">{{ dataTable.data.other_professional }}</div>
                                <div v-else>{{ dataTable.data.volunteer_professional }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_volunteer_skill == true">
                    <Column
                        field="volunteer_skill"
                        :header="$t('ปฏิบัติงานด้าน')"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_volunteer_skill == true">
                                <div v-if="dataTable.data.volunteer_skill === 'ด้านอื่นๆ'">{{ dataTable.data.other_skill }}</div>
                                <div v-else>{{ dataTable.data.volunteer_skill }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <Column
                    field="fs_tname"
                    :header="'พื้นที่รับผิดชอบสถานีดับเพลิงและกู้ภัย'"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.fs_tname }}
                    </template>
                </Column>

                <div v-if="columns_user_fullname == true">
                    <Column
                        field="updated_by"
                        :header="$t('volunteer_editor')"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_user_fullname == true">
                                {{ dataTable.data.updated_by }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_created"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ formatThaiDate(dataTable.data.date_created) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_updated"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ formatThaiDate(dataTable.data.date_updated) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- columns_update_date || -->
                <div
                    v-if="
                        columns_user_fullname ||
                        columns_index ||
                        columns_img ||
                        columns_volunteer_fullname ||
                        columns_base_operation ||
                        columns_work_status ||
                        columns_organize_name ||
                        columns_specialist_id ||
                        columns_officer_disaster ||
                        columns_officer_mobile_phone ||
                        columns_date_create ||
                        columns_date_update ||
                        columns_volunteer_skill ||
                        columns_volunteer_sex
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            manInfoModal = true;
                                            editData(dataTable.data.volunteer_id);
                                            temp = dataTable.data.volunteer_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.volunteer_id;
                                            deleteAt = '';
                                            alertDisplay(temp);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="manInfoModal"
            :style="{ width: '85%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('volunteer_modal_subtitle') }}</label>

                <p class="p-mt-5">1. ข้อมูลทั่วไป</p>
                <div class="p-fluid p-mt-2">
                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="volunteer_prefix_name">1.1 {{ $t('volunteer_prefix_name') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="volunteer_prefix_name"
                                :options="prefixOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                inputStyle="color: red;"
                                :class="{
                                    'p-invalid': error_volunteer_prefix_name && !volunteer_prefix_name
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="levelOptions">
                                    <div v-if="levelOptions.value">
                                        <div>{{ levelOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ levelOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="levelOptions">
                                    <div>{{ levelOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_volunteer_prefix_name && !volunteer_prefix_name">{{
                                $t('กรุณาระบุคำนำหน้าชื่อ')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-2">
                            <label for="location_type">{{ 'เพศ' }}</label>

                            <Dropdown
                                v-model="volunteerSex"
                                :options="volunteerSexOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                inputStyle="color: red;"
                            >
                                <template #value="sexOptions">
                                    <div v-if="sexOptions.value">
                                        <div>{{ sexOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ sexOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="sexOptions">
                                    <div>{{ sexOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="volunteer_firstname">1.2 {{ $t('volunteer_firstname') }} <span class="required-input">*</span></label>
                            <InputText
                                id="volunteer_firstname"
                                type="text"
                                v-model="volunteer_firstname"
                                autofocus
                                required="true"
                                :class="{ 'p-invalid': error_volunteer_firstname && !volunteer_firstname }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_volunteer_firstname && !volunteer_firstname">{{ $t('กรุณาระบุชื่อจริง') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="volunteer_lastname">{{ $t('volunteer_lastname') }} <span class="required-input">*</span></label>
                            <InputText
                                id="volunteer_lastname"
                                type="text"
                                v-model="volunteer_lastname"
                                :class="{ 'p-invalid': error_volunteer_lastname && !volunteer_lastname }"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_volunteer_lastname && !volunteer_lastname">{{ $t('กรุณาระบุนามสกุล') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2" style="margin-top: -5px">
                            <label for="volunteer_birth_date">1.3 วัน/เดือน/ปี เกิด<span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`1970:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="volunteer_birth_date"
                                v-model="volunteer_birth_date"
                                :class="{
                                    'p-invalid': error_volunteer_birth_date && !volunteer_birth_date
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_volunteer_birth_date && !volunteer_birth_date">กรุณาระบุ วัน/เดือน/ปี เกิด</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-1 p-mt-2">
                            <label for="location_type">{{ 'อายุ' }}</label>
                            <InputText type="text" v-model="volunteer_age" disabled style="cursor: default; opacity: 1" />
                        </div>

                        <!-- เลขบัตรประชาชน-->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="volunteer_id_card">1.4 {{ $t('volunteer_id_card') }} <span class="required-input">*</span></label>
                            <InputText
                                id="volunteer_id_card"
                                type="text"
                                v-model="volunteer_id_card"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid':
                                        (error_volunteer_id_card && !volunteer_id_card) || (volunteer_id_card && volunteer_id_card.length !== 13)
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                                @input="validateIdCard"
                                maxlength="13"
                                placeholder="กรุณากรอกข้อมูลบัตรประชาชน 13 หลัก"
                                @keypress="allowOnlyIntegers"
                            />
                            <small class="p-invalid" v-if="error_volunteer_id_card && !volunteer_id_card"> กรุณากรอกข้อมูลบัตรประชาชน 13 หลัก </small>
                            <small class="p-invalid" v-if="volunteer_id_card && volunteer_id_card.length !== 13">
                                กรุณากรอกข้อมูลบัตรประชาชน 13 หลัก
                            </small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="volunteer_tel">หมายเลขโทรศัพท์ติดต่อ<span class="required-input">*</span></label>
                            <InputText
                                id="volunteer_tel"
                                type="text"
                                v-model="volunteer_tel"
                                autofocus
                                required="true"
                                @input="acceptNumberPhone"
                                :class="{ 'p-invalid': error_volunteer_tel && volunteer_tel.length !== 12 }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_volunteer_tel && volunteer_tel.length !== 12">
                                กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก
                            </small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="volunteer_job">1.5 {{ $t('อาชีพ') }} <span class="required-input">*</span></label>
                            <InputText
                                id="volunteer_job"
                                type="text"
                                v-model="volunteer_job"
                                autofocus
                                required="true"
                                :class="{ 'p-invalid': error_volunteer_job && !volunteer_job }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_volunteer_job && !volunteer_job">{{ $t('volunteer_job_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2" style="margin-top: 5px">
                            <label for="fireStation">1.6 สถานีดับเพลิงและกู้ภัย<span class="required-input">*</span></label>
                            <Dropdown
                                v-model="FireStationSelected"
                                :options="FireStationOptions_AT"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                required="true"
                                :class="{ 'p-invalid': error_fireStation && !FireStationSelected }"
                            >
                                <template #value="FireStationOptions_AT">
                                    <div v-if="FireStationOptions_AT.value">
                                        <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                    </div>
                                    <span v-else>{{ FireStationOptions_AT.placeholder }}</span>
                                </template>
                                <template #option="FireStationOptions_AT">
                                    <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_fireStation && !FireStationSelected"> กรุณาเลือกสถานีดับเพลิงและกู้ภัย </small>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-col-12 p-lg-4 p-mt-5" style="padding-top: 9.5px">
                                <span hidden>{{ url }}</span>
                                <div class="p-grid">
                                    <div class="p-col-8 p-lg-8">
                                        <Button
                                            @click="onFileChange"
                                            class="p-button-success"
                                            icon="pi pi-plus"
                                            label="เลือกไฟล์ภาพ"
                                            ref="TextBox_6"
                                            @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                        >
                                        </Button>

                                        <input
                                            style="visibility: hidden; display: none; text-overflow: ellipsis"
                                            type="file"
                                            id="imp_uploadImageFile"
                                            @change="onFileChange"
                                            class="inputzone"
                                            accept="image/*"
                                        />
                                    </div>
                                    <div class="p-col-4 p-lg-4" style="padding-top: 0">
                                        <Button
                                            @click="clearImage()"
                                            icon="pi pi-times"
                                            class="p-button-danger"
                                            style="width: auto"
                                            :label="$t('clearImage')"
                                            ref="TextBox_7"
                                            @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                        />
                                    </div>
                                </div>

                                <div id="preview">
                                    <img v-if="url" :src="url" />
                                </div>
                                <div id="imp_image" ref="imp_image" hidden></div>
                            </div>

                            <div class="p-field p-col-12 p-lg-2">
                                <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                                <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                            </div>
                            <div class="p-field p-col-12 p-lg-2">
                                <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                                <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12 p-mt-2">
                                <p>2. ภูมิลำเนา</p>

                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <label style="margin-bottom: 10px">2.1 ภูมิลำเนา (ที่อยู่ตามทะเบียนบ้าน)</label>
                                        <InputText
                                            id="volunteer_local_address"
                                            type="text"
                                            v-model="volunteer_local_address"
                                            autofocus
                                            required="true"
                                            :class="{ 'p-invalid': error_volunteer_job && !volunteer_job }"
                                            ref="TextBox_1"
                                            @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                                        />
                                    </div>
                                </div>

                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <label style="margin-bottom: 10px">2.2 ภูมิลำเนา (ที่อยู่ปัจจุบัน)</label>
                                        <InputText
                                            :id="'course_history_' + index"
                                            type="text"
                                            v-model="volunteer_current_address"
                                            :ref="'TextBox_' + (index + 8)"
                                            @keyup.left="moveFocus($event, 'TextBox_' + (index + 7), 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_' + (index + 9), 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_' + (index + 5), 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_' + (index + 10), 'Input')"
                                        />
                                        <small class="p-invalid" v-if="error_courseSelected && !education.level">{{
                                            $t('itc_course_name_validate')
                                        }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12 p-mt-2">
                                <p>3. ประวัติการศึกษา</p>
                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                                            <label for="volunteer_course_name">ระดับการศึกษา <span class="required-input">*</span></label>
                                            <Dropdown
                                                v-model="volunteer_education_level"
                                                :options="VolunteerEducationOptions"
                                                optionLabel="system_name"
                                                :filter="true"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :showClear="true"
                                                inputStyle="color: red;"
                                                :class="{
                                                    'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                                }"
                                            >
                                                <template #value="levelOptions">
                                                    <div v-if="levelOptions.value">
                                                        <div>{{ levelOptions.value.system_name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ levelOptions.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="levelOptions">
                                                    <div>{{ levelOptions.option.system_name }}</div>
                                                </template>
                                            </Dropdown>
                                            <small class="p-invalid" v-if="error_courseSelected && !volunteer_education_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12 p-mt-2">
                                <p>4. ประวัติการฝึกอบรม</p>
                                <label>หลักสูตร</label>

                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <div v-for="(course, index) in course_history_list" :key="index" class="p-field p-col-12 p-mb-3 input-group">
                                            <InputText
                                                :id="'course_history_' + index"
                                                type="text"
                                                v-model="course.course_name"
                                                :ref="'TextBox_' + (index + 8)"
                                                @keyup.left="moveFocus($event, 'TextBox_' + (index + 7), 'Button')"
                                                @keyup.right="moveFocus($event, 'TextBox_' + (index + 9), 'Input')"
                                                @keyup.up="moveFocus($event, 'TextBox_' + (index + 5), 'Input')"
                                                @keyup.down="moveFocus($event, 'TextBox_' + (index + 10), 'Input')"
                                                class="full-width-input fixed-width-input"
                                            />
                                            <Button
                                                @click="addCourseHistory"
                                                icon="pi pi-plus"
                                                :label="$t('เพิ่มหลักสูตร')"
                                                class="p-button-success button-right-course fixed-width-button"
                                            />
                                            <Button
                                                v-if="course_history_list.length > 1"
                                                @click="removeCourseHistory(index)"
                                                icon="pi pi-minus"
                                                :label="$t('ลบหลักสูตร')"
                                                class="p-button-danger button-right-course fixed-width-button"
                                            />
                                            <small class="p-invalid" v-if="error_courseSelected && !course.course_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12 p-mt-2">
                                <div class="topic-container">
                                    <p style="padding-right: 45%">5. ปฏิบัติงานด้าน</p>
                                    <p>6. ทักษะ/ความเชี่ยวชาญ</p>
                                </div>
                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                                            <label for="volunteer_course_name">ความชำนาญ <span class="required-input">*</span></label>
                                            <Dropdown
                                                v-model="volunteerSkill"
                                                :options="volunteerSkillOptions"
                                                optionLabel="system_name"
                                                :filter="true"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :showClear="true"
                                                inputStyle="color: red;"
                                                :class="{
                                                    'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                                }"
                                            >
                                                <template #value="skillOptions">
                                                    <div v-if="skillOptions.value">
                                                        <div>{{ skillOptions.value.system_name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ skillOptions.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="skillOptions">
                                                    <div>{{ skillOptions.option.system_name }}</div>
                                                </template>
                                            </Dropdown>

                                            <div v-if="volunteerSkill && volunteerSkill.system_name === 'ด้านอื่นๆ'" class="p-mt-2">
                                                <label for="otherSkill">โปรดระบุ<span class="required-input">*</span></label>
                                                <div class="p-formgrid p-grid p-mb-3">
                                                    <div class="p-field p-col-12 p-lg-6 p-mb-3 input-group">
                                                        <InputText
                                                            :id="'otherSkill'"
                                                            type="text"
                                                            v-model="otherSkill"
                                                            :ref="'TextBox_' + (index + 8)"
                                                            @keyup.left="moveFocus($event, 'TextBox_' + (index + 7), 'Button')"
                                                            @keyup.right="moveFocus($event, 'TextBox_' + (index + 9), 'Input')"
                                                            @keyup.up="moveFocus($event, 'TextBox_' + (index + 5), 'Input')"
                                                            @keyup.down="moveFocus($event, 'TextBox_' + (index + 10), 'Input')"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <small class="p-invalid" v-if="error_courseSelected && !volunteer_education_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>

                                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                                            <label for="volunteer_course_name">เชี่ยวชาญด้าน <span class="required-input">*</span></label>
                                            <Dropdown
                                                v-model="volunteerProfessional"
                                                :options="volunteerProfessionalOptions"
                                                optionLabel="system_name"
                                                :filter="true"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :showClear="true"
                                                inputStyle="color: red;"
                                                :class="{
                                                    'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                                }"
                                            >
                                                <template #value="professionalOptions">
                                                    <div v-if="professionalOptions.value">
                                                        <div>{{ professionalOptions.value.system_name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ professionalOptions.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="professionalOptions">
                                                    <div>{{ professionalOptions.option.system_name }}</div>
                                                </template>
                                            </Dropdown>

                                            <div v-if="volunteerProfessional && volunteerProfessional.system_name === 'อื่นๆ'" class="p-mt-2">
                                                <label for="otherProfessional">โปรดระบุ<span class="required-input">*</span></label>
                                                <div class="p-formgrid p-grid p-mb-3">
                                                    <div class="p-field p-col-12 p-lg-6 p-mb-3 input-group">
                                                        <InputText
                                                            :id="'otherProfessional'"
                                                            type="text"
                                                            v-model="otherProfessional"
                                                            :ref="'TextBox_' + (index + 8)"
                                                            @keyup.left="moveFocus($event, 'TextBox_' + (index + 7), 'Button')"
                                                            @keyup.right="moveFocus($event, 'TextBox_' + (index + 9), 'Input')"
                                                            @keyup.up="moveFocus($event, 'TextBox_' + (index + 5), 'Input')"
                                                            @keyup.down="moveFocus($event, 'TextBox_' + (index + 10), 'Input')"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <small class="p-invalid" v-if="error_courseSelected && !volunteer_education_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12 p-mt-2">
                                <div class="topic-container">
                                    <p style="padding-right: 43%">7. สถานะการปฏิบัติงาน</p>
                                    <p>8. สังกัดหน่วย/ฐานปฏิบัติ</p>
                                </div>
                                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                                    <div class="p-formgrid p-grid p-mb-3">
                                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                                            <label for="volunteer_course_name">สถานะ <span class="required-input">*</span></label>
                                            <Dropdown
                                                v-model="workStatus"
                                                :options="workStatusOptions"
                                                optionLabel="system_name"
                                                :filter="true"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :showClear="true"
                                                inputStyle="color: red;"
                                                :class="{
                                                    'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                                }"
                                            >
                                                <template #value="workingStatus">
                                                    <div v-if="workingStatus.value">
                                                        <div>{{ workingStatus.value.system_name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ workingStatus.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="workingStatus">
                                                    <div>{{ workingStatus.option.system_name }}</div>
                                                </template>
                                            </Dropdown>

                                            <small class="p-invalid" v-if="error_courseSelected && !volunteer_education_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>
                                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                                            <label for="volunteer_course_name">สังกัด <span class="required-input">*</span></label>
                                            <Dropdown
                                                v-model="baseOperation"
                                                :options="baseOperationOptions"
                                                optionLabel="system_name"
                                                :filter="true"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :showClear="true"
                                                inputStyle="color: red;"
                                                :class="{
                                                    'p-invalid': error_volunteer_prefix_name && !volunteer_education_name
                                                }"
                                            >
                                                <template #value="baseOperationOption">
                                                    <div v-if="baseOperationOption.value">
                                                        <div>{{ baseOperationOption.value.system_name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ baseOperationOption.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="baseOperationOption">
                                                    <div>{{ baseOperationOption.option.system_name }}</div>
                                                </template>
                                            </Dropdown>

                                            <div v-if="baseOperation && baseOperation.system_name === 'อื่นๆ'" class="p-mt-2">
                                                <label for="otherBaseOperation">โปรดระบุ<span class="required-input">*</span></label>
                                                <div class="p-formgrid p-grid p-mb-3">
                                                    <div class="p-field p-col-12 p-lg-6 p-mb-3 input-group">
                                                        <InputText
                                                            :id="'otherBaseOperation'"
                                                            type="text"
                                                            v-model="otherBaseOperation"
                                                            :ref="'TextBox_' + (index + 8)"
                                                            @keyup.left="moveFocus($event, 'TextBox_' + (index + 7), 'Button')"
                                                            @keyup.right="moveFocus($event, 'TextBox_' + (index + 9), 'Input')"
                                                            @keyup.up="moveFocus($event, 'TextBox_' + (index + 5), 'Input')"
                                                            @keyup.down="moveFocus($event, 'TextBox_' + (index + 10), 'Input')"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <small class="p-invalid" v-if="error_courseSelected && !volunteer_education_name">{{
                                                $t('itc_course_name_validate')
                                            }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>

            <template #footer>
                <Button
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate"
                    class="p-button-text"
                    @click="isEditMode ? updateVolunteerDataDetail() : saveVolunteerDataDetail()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../FireStationTableForm.vue';
import organizeTable from '../../Report/FireStationMultiSelectTable.vue';
import axios from 'axios';

// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';
import * as XLSX from 'xlsx';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { font } from '../../../../public/assets/font/Sarabun-Regular-normal';

export default {
    name: 'initial-volunteer-bangkok',
    components: {
        organizeTable,
        organizeForm,
        textFooter
    },
    data() {
        return {
            columns_img: true,
            items: [],
            headers: [],
            page: 1,
            itemsPerPage: 10,

            columns_volunteer_sex: true,
            columns_volunteer_skill: true,
            otherSkill: '',
            otherProfessional: '',
            otherBaseOperation: '',
            course_history_list: [],
            selectOrganization: null,
            index: 0,
            columns_volunteer_professional: true,
            currentVolunteerId: '',
            manInfoModal: false,
            loadingCreate: false,
            isEditMode: false,
            volunteer_prefix_name: null,
            volunteer_sex: '',
            volunteer_firstname: '',
            volunteer_lastname: '',
            volunteer_birth_date: null,
            volunteer_age: '',
            volunteer_id_card: '',
            volunteer_tel: '',
            FireStationSelected: '',
            volunteer_local_address: '',
            volunteer_current_address: '',
            volunteer_education_name: '',
            volunteer_education_level: null,
            volunteer_education_degree: '',
            volunteer_education_major: '',
            volunteer_education_info: '',
            volunteerSkill: null,
            volunteerProfessional: null,
            workStatus: null,
            baseOperation: null,
            error_volunteer_prefix_name: false,
            error_volunteer_firstname: false,
            error_volunteer_lastname: false,
            error_volunteer_birth_date: false,
            error_volunteer_id_card: false,
            error_volunteer_tel: false,
            error_volunteer_job: false,
            error_fireStation: false,

            error_courseSelected: false,

            volunteer_job: '',
            baseOperation_search: null,
            volunteerProfessional_search: null,
            workStatus_search: null,
            volunteer_id: '',

            prefix: [],
            courseHistory: '',
            name: '',

            fireStation: null,

            FireStationOptions: [],

            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],

            ifh_FireStationSelected: null,
            error_ifh_FireStationSelected: false,

            selectedOrganizeData: null,
            userSelectedOrganize: null,
            officerId: null,

            selectItem: null,

            showVolunteerEducation: false,

            showReferalPerson: false,

            volunteer_prefix_name_referal: null,
            referal_firstname: '',
            referal_lastname: '',
            referal_position: '',

            showVolunteerParents: false,

            volunteer_prefix_name_parents: null,
            volunteer_parents_firstname: '',
            volunteer_parents_lastname: '',

            error_volunteer_position: false,

            showCurrentAddress: false,
            showLocalAddress: false,

            searchVolunteerData: [],
            totalRecords: 0,
            searchCriteria: {
                volunteer_fullname: '',
                workStatus_search: '',
                volunteerProfessional_search: '',
                baseOperation_search: ''
            },
            filter: '',
            volunteerEducation: [],
            headerVolunteerEducation: 'การศึกษา',
            showVolunteerEducationModelName: '',
            showVolunteerEducationModelLevel: null,
            showVolunteerEducationModelDegree: '',
            showVolunteerEducationModelMajor: '',
            showVolunteerEducationModelInfo: '',
            special_table: [],

            headerReferalPerson: 'ผู้รับรอง',

            showReferalPersonModelFirstname: '',
            showReferalPersonModelLastname: '',
            showReferalPersonModelPosition: '',

            headerVolunteerParents: '',
            showVolunteerParentsModelFirstname: '',
            showVolunteerParentsModelLastname: '',

            currentAddress: {
                address_no: '',
                address_village: '',
                address_alley: '',
                address_road: '',
                address_sub_district: '',
                address_district: '',
                address_province: '',
                address_more_info: ''
            },
            volunteerAddresses: [],
            headerLocalAddress: 'ภูมิลำเนา (ที่อยู่ตามทะเบียนบ้าน)',
            headerCurrentAddress: 'ถิ่นที่อยู่ (ที่อยู่ปัจจุบัน)',

            handleDateChange: true,
            tempForSaveVolunteerData: [],
            volunteerData: {
                volunteer_id: '',
                volunteer_image: '',
                volunteer_prefix: '',
                volunteer_firstname: '',
                volunteer_lastname: '',
                volunteer_birth_date: '',
                volunteer_start_date: '',
                volunteer_tel: '',
                volunteer_level_id: '',
                volunteer_position: '',
                volunteer_organize: '',
                volunteer_professional: '',
                related_disaster: '',
                training_history: '',
                editor: '',
                date_create: '',
                date_update: '',
                created_by: '',
                updated_by: '',
                flag: '',
                volunteer_id_card: ''
            },

            volunteerParents: {
                parents_prefix: '',
                parents_firstname: '',
                parents_lastname: '',
                date_create: '',
                date_update: '',
                created_by: '',
                updated_by: '',
                flag: ''
            },
            volunteerReferalPerson: {
                referal_prefix: '',
                referal_firstname: '',
                referal_lastname: '',
                referal_position: ''
            },

            VolunteerEducationOptions: [
                { system_name: 'ระดับประถมศึกษา', value: 'ระดับประถมศึกษา' },
                { system_name: 'ระดับมัธยมต้น', value: 'ระดับมัธยมต้น' },
                { system_name: 'ระดับมัธยมปลาย', value: 'ระดับมัธยมปลาย' },
                { system_name: 'ระดับอาชีวศึกษา', value: 'ระดับอาชีวศึกษา' },
                { system_name: 'ปริญญาตรี', value: 'ปริญญาตรี' },
                { system_name: 'ปริญญาโท หรือมากกว่า', value: 'ปริญญาโท หรือมากกว่า' }
            ],

            volunteerSexOptions: [
                { system_name: 'ชาย', value: 'ชาย' },
                { system_name: 'หญิง', value: 'หญิง' }
            ],

            volunteerSex: '',

            workStatusOptions: [
                { system_name: 'ปฏิบัติงานประจำ', value: 'ปฏิบัติงานประจำ' },
                { system_name: 'ปฏิบัติงานไม่ประจำ', value: 'ปฏิบัติงานไม่ประจำ' }
            ],

            volunteerSkillOptions: [
                { system_name: 'ด้านการป้องกันและบรรเทาสาธารณภัย', value: 'ด้านการป้องกันและบรรเทาสาธารณภัย' },
                { system_name: 'ด้านการเผชิญเหตุสาธารณภัย', value: 'ด้านการเผชิญเหตุสาธารณภัย' },
                { system_name: 'ด้านสงเคราะห์ผู้ประสบภัย', value: 'ด้านสงเคราะห์ผู้ประสบภัย' },
                { system_name: 'ด้านปฏิบัติการกู้ชีพกู้ภัย', value: 'ด้านปฏิบัติการกู้ชีพกู้ภัย' },
                { system_name: 'ด้านอื่นๆ', value: 'ด้านอื่นๆ' }
            ],

            volunteerProfessionalOptions: [
                { system_name: 'การดับเพลิง', value: 'การดับเพลิง' },
                { system_name: 'การกู้ภัยสารเคมี', value: 'การกู้ภัยสารเคมี' },
                { system_name: 'การกู้ภัยทางน้ำ', value: 'การกู้ภัยทางน้ำ' },
                { system_name: 'การกู้ชีพ', value: 'การกู้ชีพ' },
                { system_name: 'การกู้ภัยอุบัติเหตุบนท้องถนน', value: 'การกู้ภัยอุบัติเหตุบนท้องถนน' },
                { system_name: 'การกู้ภัยในที่สูง', value: 'การกู้ภัยในที่สูง' },
                { system_name: 'การกู้ภัยในที่อับอากาศ', value: 'การกู้ภัยในที่อับอากาศ' },
                { system_name: 'อื่นๆ', value: 'อื่นๆ' }
            ],

            baseOperationOptions: [
                { system_name: 'มูลนิธิร่วมกตัญญู', value: 'มูลนิธิร่วมกตัญญู' },
                { system_name: 'มูลนิธิป่อ เต็ก ตึ๊ง', value: 'มูลนิธิป่อ เต็ก ตึ๊ง' },
                { system_name: 'การกู้ภัยทางน้ำ', value: 'การกู้ภัยทางน้ำ' },
                { system_name: 'มูลนิธิกู้ภัยร่มไทร', value: 'มูลนิธิกู้ภัยร่มไทร' },
                { system_name: 'มูลนิธิสยามรวมใจ', value: 'มูลนิธิสยามรวมใจ' },
                { system_name: 'นครหลวงพุทธสมาคม', value: 'นครหลวงพุทธสมาคม' },
                { system_name: 'สมาคมอาสาสมัครบรรเทาสาธารณภัยแห่งประเทศไทย', value: 'สมาคมอาสาสมัครบรรเทาสาธารณภัยแห่งประเทศไทย' },
                { system_name: 'อื่นๆ', value: 'อื่นๆ' }
            ],

            volunteer_work_status: '',
            VolunteerLevelOptions: [
                { system_name: 'ชำนาญการพิเศษ', value: 'ชำนาญการพิเศษ' },
                { system_name: 'ชำนาญงาน', value: 'ชำนาญงาน' },
                { system_name: 'ต้น', value: 'ต้น' },
                { system_name: 'ปฏิบัติการ', value: 'ปฏิบัติการ' },
                { system_name: 'ปฏิบัติการหรือชำนาญ', value: 'ปฏิบัติการหรือชำนาญ' },
                { system_name: 'ปฏิบัติงาน', value: 'ปฏิบัติงาน' },
                { system_name: 'ปฏิบัติงานหรือชำนาญงาน', value: 'ปฏิบัติงานหรือชำนาญงาน' },
                { system_name: 'สูง', value: 'สูง' },
                { system_name: 'อาวุโส', value: 'อาวุโส' }
            ],

            volunteer_start_date: null,
            volunteer_birth_date_timestamp: null,
            volunteer_start_date_timestamp: null,

            volunteer_phone_number: '',
            volunteer_position: '',
            volunteer_level: '',
            volunteer_organize: { name: '' },
            date_create_form: '',
            date_update_form: '',
            url: '',

            error_volunteer_organize: false,
            volunteer_image: '',
            volunteer_prefix: '',

            volunteer_level_id: '',

            volunteer_professional: '',
            related_disaster: '',
            editor: '',
            showLocalAddressModeVillage: '',

            volunteer_referal_person: [],
            volunteer_parents: [],
            volunteer_education: [],
            showLocalAddressModelNo: '',
            address_no: '',
            address_village: '',
            address_alley: '',
            address_road: '',
            address_sub_district: '',
            address_district: '',
            address_province: '',
            address_more_info: '',
            date_create: '',
            date_update: '',
            created_by: '',
            updated_by: '',
            flags: '',
            showCurrentAddressModelMoreInfo: '',
            showCurrentAddressModelProvince: '',
            showCurrentAddressModelDistrict: '',
            showCurrentAddressModelSubDistrict: '',
            showCurrentAddressModelRoad: '',
            showCurrentAddressModelAlley: '',
            showCurrentAddressModelVillage: '',
            showCurrentAddressModelNo: '',
            showLocalAddressModelMoreInfo: '',
            showLocalAddressModelProvince: '',
            showLocalAddressModelSubDistrict: '',
            showLocalAddressModelDistrict: '',
            showLocalAddressModelRoad: '',
            localAddressVillage: '',
            localAddressNo: '',
            showVolunteerEducationModel: null,
            educationOptions: ['ระดับปฐมศึกษา', 'ระดับมัธยมศึกษา', 'ระดับอาชีวศึกษา', 'ระดับอุดมศึกษา', 'การศึกษาพิเศษ'],

            showCureentAddressModel: '',
            updatedDate: '',
            volunteer_start_workDate: '',
            volunteer_register_date: '',
            volunteer_disaster: [],
            history_table: [],
            levelOptions: [],
            skillOptions: [],
            workingStatus: [],
            professionalOptions: [],
            baseOperationOption: [],
            check_update_info: false,

            temp: null,
            displayBasic2: false,
            imgTable: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),
            // Doe ค้นหา  2/6
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            th: this.$thaidate,
            fullname: '',
            selectedOrganize: {},
            selectedGenDate: { name: this.$i18n.t('volunteer_gen'), value: 'gen' },
            genDate: [
                { name: this.$i18n.t('volunteer_gen'), value: 'gen' },
                { name: this.$i18n.t('volunteer_date'), value: 'date' }
            ],
            searchby: '',

            levelSelected: null,
            disasterTypeOptions: [],
            disasterTypeSelected: null,
            courseOptions: [],
            courseSelected: null,

            courseLevelOptions: [],
            specialOptions: [],
            prefixOptions: [],
            selectedTrainingData: null,
            displayConfirmation: false,
            specialDelete: {},
            disasterDelete: {},
            historyDelete: {},
            deleteAt: '',
            filters: {},
            selectedManInfo: [],
            manInfo_Table: [],
            trainingCourse_Table: [],

            showOrganize: false,
            showOrganize_Form: false,
            showCourseHistory: false,
            selectedData: '',

            volunteer_update_info: [],

            volunteer_mobile_phone_number: '',
            volunteer_fax: '',
            volunteer_email: '',
            volunteer_radio_signal: '',
            volunteer_response_signal: '',
            volunteer_secretary_name: '',
            volunteer_secretary_phone: '',
            volunteer_update_info_date: '',
            volunteer_update_info_date_save: '',
            volunteer_detail: '',

            courseLevelSelected: null,
            volunteer_course_name: null,

            disaster_table: [],
            volunteer_special: null,
            error_volunteer_level: false,

            error_volunteer_start_workDate: false,
            header: this.$i18n.t('volunteer_modal_title_add'),
            headerDetail: this.$i18n.t('volunteer_modal_title_add_trainingHistory'),

            headerParents: this.$i18n.t('volunteer_parents'),

            check_duplicate: '',
            error_email_format: false,
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            loading: false,

            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อ-นามสกุล',
                    textShow: ''
                },
                {
                    DataName: 'ระดับ',
                    textShow: ''
                },
                {
                    DataName: 'สาธารณภัยที่เกี่ยวข้อง',
                    textShow: ''
                },
                {
                    DataName: 'หลักสูตรการฝึกอบรม',
                    textShow: ''
                },
                {
                    DataName: 'รุ่นที่/วันที่',
                    textShow: ''
                },
                {
                    DataName: 'ต้องปรับปรุงข้อมูล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 60,
            PDF_FontHeaderVer: 10,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },
                volunteer_fullname: { cellWidth: 55 },
                work_status: { cellWidth: 45 },
                organize_name: { cellWidth: 60 },
                specialist_id: { cellWidth: 40 },
                officer_response_signal: { cellWidth: 45 },
                // officer_mobile_phone:{cellWidth:55},
                text_tel_detail: { cellWidth: 60 },
                // update_date:{cellWidth:65}
                user_fullname: { cellWidth: 45 },
                date_update_ddmmyy: { cellWidth: 65 }
            },

            PDF_minCellWidthHor: 80,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 9,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 50 },
                birth_date: { cellWidth: 50 },
                work_status: { cellWidth: 50 },
                date_created: { cellWidth: 50 },
                base_operation: { cellWidth: 50 },
                specialist_id: { cellWidth: 50 },
                fs_tname: { cellWidth: 50 },
                updated_by: { cellWidth: 50 },
                date_updated: { cellWidth: 50 },
                volunteer_tel: { cellWidth: 50 }
            },
            volunteer_fullname: '',
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อ-นามสกุล', dataKey: 'volunteer_fullname' },
                { title: 'วัน/เดือน/ปี เกิด', dataKey: 'birth_date' },
                { title: 'หมายเลขโทรศัพท์ติดต่อ', dataKey: 'volunteer_tel' },
                { title: 'สถานะการปฏิบัติงาน', dataKey: 'work_status' },
                { title: 'สังกัดหน่วย/ฐานปฏิบัติ', dataKey: 'base_operation' },
                { title: 'ความเชี่ยวชาญ', dataKey: 'volunteer_professional' },
                { title: 'พื้นที่รับผิดชอบสถานีดับเพลิงและกู้ภัย', dataKey: 'fs_tname' },
                { title: 'ปรับปรุงโดย', dataKey: 'updated_by' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_created' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_updated' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            // columns_index: true,
            // columns_img: true,
            // columns_volunteer_fullname: true,
            // columns_base_operation: true,
            // columns_work_status: true,
            // columns_organize_name: true,
            // columns_specialist_id: true,
            // columns_officer_response_signal: true,
            // columns_officer_mobile_phone: true,
            // columns_update_date: true,
            // columns_user_fullname: true,

            columns_index: true,
            columns_volunteer_fullname: true,
            columns_work_status: true,
            columns_base_operation: true,
            columns_specialist_id: true,
            columns_user_fullname: true,
            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            itemsPDF: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'volunteer_image';
                        });

                        const Body_setCenter = ['index', 'work_status', 'officer_response_signal'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'volunteer_image';
                        });

                        const Body_setCenter = ['index', 'work_status', 'officer_response_signal'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ],
            // Doe : PDF 3/3 จบ

            formatDatePDF(date) {
                const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return new Date(date).toLocaleDateString('th-TH', options);
            },

            // generatePDF() {
            //     // Load Sarabun font for Thai language support
            //     const doc = new jsPDF('l'); // 'l' for landscape orientation
            //     doc.addFileToVFS('Sarabun-Regular.ttf', font);
            //     doc.addFont('Sarabun-Regular.ttf', 'Sarabun', 'normal');
            //     doc.setFont('Sarabun');

            //     // Filter out the volunteer image column and format date fields
            //     let columns = this.columnsSelector.filter((item) => item.dataKey !== 'volunteer_image');
            //     const formattedData = this.$refs.dt.processedData.map((row) => ({
            //         ...row,
            //         date_created: this.formatDatePDF(row.date_created),
            //         date_updated: this.formatDatePDF(row.date_updated)
            //     }));

            //     // Define multilevel headers for the PDF
            //     const headers = [
            //         [
            //             { content: 'ที่', rowSpan: 2 },
            //             { content: 'ชื่อสกุล', rowSpan: 2 },
            //             { content: 'สังกัดหน่วย/ฐานปฏิบัติ', rowSpan: 2 }, // Moved base_operation here
            //             { content: 'เพศ', colSpan: 2 },
            //             { content: 'สถานะการปฏิบัติงาน', colSpan: 2 },
            //             { content: 'ฝ่ายการป้องกันและบรรเทาสาธารณภัย', rowSpan: 2 },
            //             { content: 'ฝ่ายรักษาความสงบเรียบร้อย', rowSpan: 2 },
            //             { content: 'ฝ่ายสงเคราะห์ผู้ประสบภัย', rowSpan: 2 },
            //             { content: 'ฝ่ายปฏิบัติการกู้ชีพกู้ภัย', rowSpan: 2 },
            //             { content: 'ฝ่ายอื่นๆ', rowSpan: 2 },
            //             { content: 'หมายเหตุ', rowSpan: 2 }
            //         ],
            //         [{ content: 'ชาย' }, { content: 'หญิง' }, { content: 'ปฏิบัติงานประจำ' }, { content: 'ปฏิบัติงานไม่ประจำ' }]
            //     ];

            //     // Map data to match the structure of headers
            //     const rows = formattedData.map((item, index) => [
            //         (this.page - 1) * this.itemsPerPage + index + 1,
            //         item.volunteer_fullname,
            //         item.base_operation || '-',
            //         item.volunteer_sex === 'ชาย' ? 'ชาย' : '-',
            //         item.volunteer_sex === 'หญิง' ? 'หญิง' : '-',
            //         item.work_status === 'ปฏิบัติงานประจำ' ? 'ปฏิบัติงานประจำ' : '-',
            //         item.work_status === 'ปฏิบัติงานไม่ประจำ' ? 'ปฏิบัติงานไม่ประจำ' : '-',
            //         item.volunteer_skill.includes('บรรเทาสาธารณภัย') ? 'บรรเทาสาธารณภัย' : '-',
            //         item.volunteer_skill.includes('เผชิญเหตุ') ? 'ฝ่ายรักษาความสงบเรียบร้อย' : '-',
            //         item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย') ? 'สงเคราะห์ผู้ประสบภัย' : '-',
            //         item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ภัย') ? 'ฝ่ายปฏิบัติการกู้ชีพกู้ภัย' : '-',
            //         item.volunteer_skill.includes('อื่นๆ') ? 'อื่นๆ' : '-',
            //         item.other_skill || '-',
            //         item.fs_tname || '-'
            //     ]);

            //     // Add summary row (totals)
            //     const totalVolunteer = formattedData.length;
            //     const totalMale = formattedData.filter((item) => item.volunteer_sex === 'ชาย').length;
            //     const totalFemale = formattedData.filter((item) => item.volunteer_sex === 'หญิง').length;
            //     const totalRegular = formattedData.filter((item) => item.work_status === 'ปฏิบัติงานประจำ').length;
            //     const totalIrregular = formattedData.filter((item) => item.work_status === 'ปฏิบัติงานไม่ประจำ').length;
            //     const totalDisasterRelief = formattedData.filter((item) => item.volunteer_skill.includes('บรรเทาสาธารณภัย')).length;
            //     const totalSecurity = formattedData.filter((item) => item.volunteer_skill.includes('เผชิญเหตุ')).length;
            //     const totalAid = formattedData.filter((item) => item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย')).length;
            //     const totalRescue = formattedData.filter((item) => item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ชีพ')).length;
            //     const totalOther = formattedData.filter((item) => item.volunteer_skill.includes('อื่นๆ')).length;

            //     const summaryRow = [
            //         'รวม',
            //         totalVolunteer,
            //         '-',
            //         totalMale,
            //         totalFemale,
            //         totalRegular,
            //         totalIrregular,
            //         totalDisasterRelief,
            //         totalSecurity,
            //         totalAid,
            //         totalRescue,
            //         totalOther,
            //         '-',
            //         '-'
            //     ];
            //     rows.push(summaryRow);

            //     // Extract fs_tname values and determine if they are all the same
            //     const fsTnames = formattedData.map((item) => item.fs_tname).filter(Boolean);
            //     const uniqueFsTnames = [...new Set(fsTnames)];
            //     const textSub =
            //         uniqueFsTnames.length === 1
            //             ? `พื้นที่รับผิดชอบสถานีดับเพลิงและกู้ภัย ${uniqueFsTnames[0]}`
            //             : 'พื้นที่รับผิดชอบสถานีดับเพลิงและกู้ภัย ทั้งหมด';

            //     // Calculate dynamic margins for centering
            //     const pageWidth = doc.internal.pageSize.getWidth();
            //     const tableWidth = pageWidth - 20; // Adjust this value for table width constraints

            //     // Configure autoTable with styles and content
            //     doc.autoTable({
            //         head: headers,
            //         body: rows,
            //         startY: 20,
            //         tableWidth: tableWidth, // Set table width for a balanced view
            //         margin: { left: (pageWidth - tableWidth) / 2, right: (pageWidth - tableWidth) / 2 }, // Center the table
            //         styles: {
            //             font: 'Sarabun',
            //             fontSize: this.PDF_FontBodyVer || 10,
            //             cellPadding: 3,
            //             lineWidth: 0.1,
            //             lineColor: [0, 0, 0],
            //             halign: 'center',
            //             valign: 'middle',
            //             overflow: 'linebreak'
            //         },
            //         headStyles: {
            //             fillColor: [0, 102, 204], // Set a blue color for header
            //             textColor: 255,
            //             fontSize: this.PDF_FontHeaderVer || 18,
            //             fontStyle: 'bold'
            //         },
            //         columnStyles: {
            //             0: { cellWidth: 15 }, // Column width for "ที่"
            //             1: { cellWidth: 25 }, // Column width for "ชื่อสกุล"
            //             2: { cellWidth: 25 }, // Column width for "สังกัดหน่วย/ฐานปฏิบัติ"
            //             3: { cellWidth: 15 },
            //             4: { cellWidth: 15 },
            //             5: { cellWidth: 25 },
            //             6: { cellWidth: 25 },
            //             7: { cellWidth: 25 },
            //             8: { cellWidth: 25 },
            //             9: { cellWidth: 25 },
            //             10: { cellWidth: 25 },
            //             11: { cellWidth: 25 },
            //             12: { cellWidth: 15 },
            //             13: { cellWidth: 15 }
            //         },
            //         theme: 'grid',
            //         didDrawPage: function (data) {
            //             // Optional header
            //             doc.setFontSize(14);
            //             const pageWidth = doc.internal.pageSize.getWidth();
            //             const text = 'รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร';
            //             const textWidth = doc.getTextWidth(text);
            //             const textX = (pageWidth - textWidth) / 2;
            //             doc.text(text, textX, 10);

            //             // Optional sub header center
            //             doc.setFontSize(12);
            //             const textSubWidth = doc.getTextWidth(textSub);
            //             const textSubX = (pageWidth - textSubWidth) / 2;
            //             doc.text(textSub, textSubX, 15);

            //             // Date report
            //             const date = new Date().toLocaleDateString('th-TH', {
            //                 month: 'long',
            //                 year: 'numeric',
            //                 day: 'numeric'
            //             });

            //             const dateText = 'วันที่ ' + date;
            //             const dateTextWidth = doc.getTextWidth(dateText);
            //             const dateTextX = pageWidth - dateTextWidth - 15;
            //             doc.text(dateText, dateTextX, 15);

            //             // Optional footer
            //             doc.setFontSize(10);
            //             const footerText = 'หน้า ' + doc.internal.getNumberOfPages();
            //             const footerTextWidth = doc.getTextWidth(footerText);
            //             const footerTextX = (pageWidth - footerTextWidth) / 2;
            //             doc.text(footerText, footerTextX, doc.internal.pageSize.getHeight() - 10);
            //         }
            //     });

            //     // Save the generated PDF
            //     const date = new Date()
            //         .toLocaleDateString('th-TH', {
            //             year: 'numeric',
            //             month: '2-digit',
            //             day: '2-digit'
            //         })
            //         .replace(/\//g, '-');
            //     doc.save(`รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร-${date}.pdf`);
            // }

            generatePDF() {
                // Load Sarabun font for Thai language support
                const doc = new jsPDF('l'); // 'l' for landscape orientation
                doc.addFileToVFS('Sarabun-Regular.ttf', font);
                doc.addFont('Sarabun-Regular.ttf', 'Sarabun', 'normal');
                doc.setFont('Sarabun');

                // Filter out the volunteer image column and format date fields
                let columns = this.columnsSelector.filter((item) => item.dataKey !== 'volunteer_image');
                const formattedData = this.$refs.dt.processedData.map((row) => ({
                    ...row,
                    date_created: this.formatDatePDF(row.date_created),
                    date_updated: this.formatDatePDF(row.date_updated)
                }));

                // Extract unique fs_tname values
                const fsTnames = [...new Set(formattedData.map((item) => item.fs_tname).filter(Boolean))];

                fsTnames.forEach((fsTname, index) => {
                    // Filter data for the current fs_tname
                    const dataForFsTname = formattedData.filter((item) => item.fs_tname === fsTname);

                    // Define multilevel headers for the PDF
                    const headers = [
                        [
                            { content: 'ที่', rowSpan: 2 },
                            { content: 'ชื่อสกุล', rowSpan: 2 },
                            { content: 'สังกัดหน่วย/ฐานปฏิบัติ', rowSpan: 2 }, // Moved base_operation here
                            { content: 'เพศ', colSpan: 2 },
                            { content: 'สถานะการปฏิบัติงาน', colSpan: 2 },
                            { content: 'ฝ่ายการป้องกันและบรรเทาสาธารณภัย', rowSpan: 2 },
                            { content: 'ฝ่ายรักษาความสงบเรียบร้อย', rowSpan: 2 },
                            { content: 'ฝ่ายสงเคราะห์ผู้ประสบภัย', rowSpan: 2 },
                            { content: 'ฝ่ายปฏิบัติการกู้ชีพกู้ภัย', rowSpan: 2 },
                            { content: 'ฝ่ายอื่นๆ', rowSpan: 2 },
                            { content: 'หมายเหตุ', rowSpan: 2 }
                        ],
                        [{ content: 'ชาย' }, { content: 'หญิง' }, { content: 'ปฏิบัติงานประจำ' }, { content: 'ปฏิบัติงานไม่ประจำ' }]
                    ];

                    // Map data to match the structure of headers
                    const rows = dataForFsTname.map((item, index) => [
                        (this.page - 1) * this.itemsPerPage + index + 1,
                        item.volunteer_fullname,
                        item.base_operation || '-',
                        item.volunteer_sex === 'ชาย' ? 'ชาย' : '-',
                        item.volunteer_sex === 'หญิง' ? 'หญิง' : '-',
                        item.work_status === 'ปฏิบัติงานประจำ' ? 'ปฏิบัติงานประจำ' : '-',
                        item.work_status === 'ปฏิบัติงานไม่ประจำ' ? 'ปฏิบัติงานไม่ประจำ' : '-',
                        item.volunteer_skill.includes('บรรเทาสาธารณภัย') ? 'บรรเทาสาธารณภัย' : '-',
                        item.volunteer_skill.includes('เผชิญเหตุ') ? 'ฝ่ายรักษาความสงบเรียบร้อย' : '-',
                        item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย') ? 'สงเคราะห์ผู้ประสบภัย' : '-',
                        item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ภัย') ? 'ฝ่ายปฏิบัติการกู้ชีพกู้ภัย' : '-',
                        item.volunteer_skill.includes('อื่นๆ') ? 'อื่นๆ' : '-',
                        item.other_skill || '-',
                        item.fs_tname || '-'
                    ]);

                    // Add summary row (totals)
                    const totalVolunteer = dataForFsTname.length;
                    const totalMale = dataForFsTname.filter((item) => item.volunteer_sex === 'ชาย').length;
                    const totalFemale = dataForFsTname.filter((item) => item.volunteer_sex === 'หญิง').length;
                    const totalRegular = dataForFsTname.filter((item) => item.work_status === 'ปฏิบัติงานประจำ').length;
                    const totalIrregular = dataForFsTname.filter((item) => item.work_status === 'ปฏิบัติงานไม่ประจำ').length;
                    const totalDisasterRelief = dataForFsTname.filter((item) => item.volunteer_skill.includes('บรรเทาสาธารณภัย')).length;
                    const totalSecurity = dataForFsTname.filter((item) => item.volunteer_skill.includes('เผชิญเหตุ')).length;
                    const totalAid = dataForFsTname.filter((item) => item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย')).length;
                    const totalRescue = dataForFsTname.filter((item) => item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ชีพ')).length;
                    const totalOther = dataForFsTname.filter((item) => item.volunteer_skill.includes('อื่นๆ')).length;

                    const summaryRow = [
                        'รวม',
                        totalVolunteer,
                        '-',
                        totalMale,
                        totalFemale,
                        totalRegular,
                        totalIrregular,
                        totalDisasterRelief,
                        totalSecurity,
                        totalAid,
                        totalRescue,
                        totalOther,
                        '-',
                        '-'
                    ];
                    rows.push(summaryRow);

                    const textSub = `พื้นที่รับผิดชอบ ${fsTname}`;

                    // Calculate dynamic margins for centering
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const tableWidth = pageWidth - 20; // Adjust this value for table width constraints

                    // Add a new page for each table except the first one
                    if (index > 0) {
                        doc.addPage();
                    }

                    // Configure autoTable with styles and content
                    doc.autoTable({
                        head: headers,
                        body: rows,
                        startY: 20,
                        tableWidth: tableWidth, // Set table width for a balanced view
                        margin: { left: (pageWidth - tableWidth) / 2, right: (pageWidth - tableWidth) / 2 }, // Center the table
                        styles: {
                            font: 'Sarabun',
                            fontSize: this.PDF_FontBodyVer || 10,
                            cellPadding: 3,
                            lineWidth: 0.1,
                            lineColor: [0, 0, 0],
                            halign: 'center',
                            valign: 'middle',
                            overflow: 'linebreak'
                        },
                        headStyles: {
                            fillColor: [0, 102, 204], // Set a blue color for header
                            textColor: 255,
                            fontSize: this.PDF_FontHeaderVer || 18,
                            fontStyle: 'bold'
                        },
                        columnStyles: {
                            0: { cellWidth: 15 }, // Column width for "ที่"
                            1: { cellWidth: 25 }, // Column width for "ชื่อสกุล"
                            2: { cellWidth: 25 }, // Column width for "สังกัดหน่วย/ฐานปฏิบัติ"
                            3: { cellWidth: 15 },
                            4: { cellWidth: 15 },
                            5: { cellWidth: 25 },
                            6: { cellWidth: 25 },
                            7: { cellWidth: 25 },
                            8: { cellWidth: 25 },
                            9: { cellWidth: 25 },
                            10: { cellWidth: 25 },
                            11: { cellWidth: 25 },
                            12: { cellWidth: 15 },
                            13: { cellWidth: 15 }
                        },
                        theme: 'grid',
                        didDrawPage: function (data) {
                            // Optional header
                            doc.setFontSize(14);
                            const pageWidth = doc.internal.pageSize.getWidth();
                            const text = 'รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร';
                            const textWidth = doc.getTextWidth(text);
                            const textX = (pageWidth - textWidth) / 2;
                            doc.text(text, textX, 10);

                            // Optional sub header center
                            doc.setFontSize(12);
                            const textSubWidth = doc.getTextWidth(textSub);
                            const textSubX = (pageWidth - textSubWidth) / 2;
                            doc.text(textSub, textSubX, 15);

                            // Date report
                            const date = new Date().toLocaleDateString('th-TH', {
                                month: 'long',
                                year: 'numeric',
                                day: 'numeric'
                            });

                            const dateText = 'วันที่ ' + date;
                            const dateTextWidth = doc.getTextWidth(dateText);
                            const dateTextX = pageWidth - dateTextWidth - 15;
                            doc.text(dateText, dateTextX, 15);

                            // Optional footer
                            doc.setFontSize(10);
                            const footerText = 'หน้า ' + doc.internal.getNumberOfPages();
                            const footerTextWidth = doc.getTextWidth(footerText);
                            const footerTextX = (pageWidth - footerTextWidth) / 2;
                            doc.text(footerText, footerTextX, doc.internal.pageSize.getHeight() - 10);
                        }
                    });
                });

                // Save the generated PDF
                const date = new Date()
                    .toLocaleDateString('th-TH', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    })
                    .replace(/\//g, '-');
                doc.save(`รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร-${date}.pdf`);
            }
        };
    },
    watch: {
        volunteer_birth_date(newDate) {
            if (newDate) {
                this.volunteer_age = this.calculateAge(newDate);
            } else {
                this.volunteer_age = '';
            }
        },

        async showCourseHistory(val) {
            if (val == false) {
                this.trainingCourse_Table = [];
                this.volunteer_course_name = null;
                this.courseLevelSelected = null;
                this.error_courseSelected = false;
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => {
                        (this.courseOptions = response.data.data),
                            this.courseOptions.splice(0, 0, {
                                course_id: 'getall',
                                course_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                if (this.history_table != []) {
                    this.selectedTrainingData = this.history_table;
                }
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-06' }
                    })
                    .then((response) => {
                        this.courseLevelOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => (this.courseOptions = response.data.data));
            }
        },

        async manInfoModal(val) {
            //check is EditMode

            if (this.isEditMode == false) {
                this.header = this.$i18n.t('volunteerbkk_modal_title_add');
            }

            // console.log('this.isEditMode = ' + this.isEditMode);
            if (val == false) {
                this.clearData();
                this.isEditMode = false;
                this.header = this.$i18n.t('volunteerbkk_modal_title_add');
                this.selectedData = null;
                this.FireStationSelected = null;

                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.volunteer_prefix_name != null &&
                    this.volunteer_firstname != '' &&
                    this.volunteer_lastname != '' &&
                    this.volunteer_organize.name != undefined
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.tempFor_displayConfirmationCloseModal = '';
                            this.volunteer_prefix_name = null;
                            this.volunteerSex = null;
                            this.volunteer_firstname = '';
                            this.volunteer_lastname = '';
                            this.url = null;
                            document.getElementById('volunteer_uploadImageFile').value = '';
                            this.volunteer_birth_date = null;
                            this.volunteer_age = '';
                            this.volunteer_id_card = '';
                            this.volunteer_tel = '';
                            this.volunteer_job = '';
                            this.FireStationSelected = null;
                            this.volunteer_local_address = '';
                            this.volunteer_current_address = '';
                            this.volunteer_education_level = null;
                            this.course.course_name = '';
                            this.volunteerSkill = null;
                            this.otherSkill = '';
                            this.volunteerProfessional = null;
                            this.otherProfessional = '';
                            this.workStatus = null;
                            this.baseOperation = null;
                            this.otherBaseOperation = '';
                            this.volunteer_organize = {};

                            this.error_volunteer_prefix_name = false;
                            this.error_volunteer_firstname = false;
                            this.error_volunteer_lastname = false;
                            this.error_volunteer_organize = false;
                            this.error_volunteer_start_workDate = false;
                            this.error_volunteer_level = false;
                            this.error_email_format = false;

                            this.contact_phone = '';
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.date_create_form = '';
                            this.date_update_form = '';
                            this.fireStation = null;
                            this.error_fireStation = false;
                        } else {
                            this.manInfoModal = true;
                        }
                    });
                } else {
                    // สลับมาอยู่บน
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-08' }
                        })
                        .then((response) => {
                            (this.levelOptions = response.data.data),
                                this.levelOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/course`, {
                            body: { topic: 'get-option' }
                        })
                        .then((response) => {
                            (this.courseOptions = response.data.data),
                                this.courseOptions.splice(0, 0, {
                                    course_id: 'getall',
                                    course_name: this.$i18n.t('selectAll')
                                });
                        });
                    // this.clearData();
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = this.checkDate_showEN(new Date());
                    this.date_update_form = this.checkDate_showEN(new Date());

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.volunteer_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-07' }
                    })
                    .then((response) => {
                        this.specialOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-08' }
                    })
                    .then((response) => {
                        this.levelOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-13' }
                    })
                    .then((response) => {
                        this.prefixOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => (this.courseOptions = response.data.data));

                if (this.selectedData == '') {
                    const lastest = new Date();
                    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(lastest);
                    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(lastest);
                    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(lastest);
                    var ye_th = Number(ye) + 543;
                    this.volunteer_update_info_date = `${da}/${mo}/${ye_th}`;
                    this.volunteer_update_info_date_save = `${ye}-${mo}-${da}`;
                }
                // else{

                //   this.volunteer_start_workDate = this.formatDateString(this.volunteer_start_workDate)

                // }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.manInfoModal = true;
            }
        },

        DCM(val) {
            if (val == true) {
                this.manInfoModal = true;
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.officer_level_id == 'null') {
                    this.volunteer_level = null;
                } else {
                    this.volunteer_level = {
                        system_id: val.officer_level_id,
                        system_name: val.work_status
                    };
                }
            }
        },

        volunteer_start_workDate(val) {
            if (val == null) {
                this.volunteer_start_workDate = '';
            }
        },

        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.manInfo_Table = [];
            } else {
                this.manInfo_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },

        volunteer_special(val) {
            if (val != null) {
                this.special_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.special_table.push(val[i]);
                }
            }
        },

        volunteer_disaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },
        selectedGenDate(val) {
            if (val.value !== 'gen') {
                this.searchby = '';
            } else {
                this.searchby = '';
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        // this.fetchData();

        if (this.editData && this.editData.course_history) {
            this.course_history_list = this.editData.course_history.split(',').map((course) => ({ course_name: course }));
        } else {
            this.course_history_list = [{ course_name: '' }];
        }

        this.fetchFireStations();
    },

    computed: {
        paginatedItems() {
            const start = (this.page - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.items.slice(start, end);
        },
        pageCount() {
            return Math.ceil(this.items.length / this.itemsPerPage);
        }
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedManInfo.map((item) => ({
                    volunteer_id: item.volunteer_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/update/volunteer-bangkok/dates?user=${userId}`, {
                    body: {
                        selectedManInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.manInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลอาสาสมัครจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchManInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedManInfo = [...this.manInfo_Table];
            } else {
                this.selectedManInfo = [];
            }
            this.$emit('selectedManInfo', this.selectedManInfo);
            console.log('selectedManInfo', this.selectedManInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedManInfo.some((item) => item.volunteer_id === row.volunteer_id)) {
                    this.selectedManInfo.push(row);
                }
            } else {
                this.selectedManInfo = this.selectedManInfo.filter((item) => item.volunteer_id !== row.volunteer_id);
            }
            this.$emit('selectedManInfo', this.selectedManInfo);
            console.log('selectedManInfo', this.selectedManInfo);
        },

        openModal() {
            this.setDefault();
            this.isEditMode = false;
            this.manInfoModal = true;
        },

        isValidPhoneNumber(phone) {
            const phoneRegex = /^\d{10}$/;
            return phoneRegex.test(phone);
        },

        exportExcel() {
            const ws = XLSX.utils.json_to_sheet(this.convertToExcelData(this.items), { skipHeader: true });
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Data');

            // Merge cells for multilevel headers
            ws['!merges'] = [
                { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
                { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
                { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
                { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
                { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
                { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } },
                { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } },
                { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } },
                { s: { r: 0, c: 10 }, e: { r: 1, c: 10 } },
                { s: { r: 0, c: 11 }, e: { r: 1, c: 11 } },
                { s: { r: 0, c: 12 }, e: { r: 1, c: 12 } }
            ];

            const date = new Date()
                .toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                })
                .replace(/\//g, '-');
            XLSX.writeFile(wb, `รายงานข้อมูลจำนวนอาสาสมัครในพื้นที่กรุงเทพมหานคร-${date}.xlsx`);
        },

        convertToExcelData(items) {
            const headers = [
                [
                    'ที่',
                    'ชื่อสกุล',
                    'สังกัดหน่วย/ฐานปฏิบัติ',
                    'เพศ',
                    '',
                    'สถานะการปฏิบัติงาน',
                    '',
                    'ฝ่ายการป้องกันและบรรเทาสาธารณภัย',
                    'ฝ่ายรักษาความสงบเรียบร้อย',
                    'ฝ่ายสงเคราะห์ผู้ประสบภัย',
                    'ฝ่ายปฏิบัติการกู้ชีพกู้ภัย',
                    'ฝ่ายอื่นๆ',
                    'หมายเหตุ'
                ],
                ['', '', '', 'ชาย', 'หญิง', 'ปฏิบัติงานประจำ', 'ปฏิบัติงานไม่ประจำ', '', '', '', '', '', '']
            ];
            const rows = items.map((item, index) => [
                (this.page - 1) * this.itemsPerPage + index + 1,
                item.volunteer_fullname,
                item.base_operation,
                item.volunteer_sex === 'ชาย' ? '✔' : '',
                item.volunteer_sex === 'หญิง' ? '✔' : '',
                item.work_status === 'ปฏิบัติงานประจำ' ? '✔' : '',
                item.work_status === 'ปฏิบัติงานไม่ประจำ' ? '✔' : '',
                item.volunteer_skill.includes('บรรเทาสาธารณภัย') ? '✔' : '',
                item.volunteer_skill.includes('เผชิญเหตุ') ? '✔' : '',
                item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย') ? '✔' : '',
                item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ภัย') ? '✔' : '',
                item.volunteer_skill.includes('อื่นๆ') ? '✔' : '',
                item.other_skill
            ]);

            const totalVolunteer = items.length;
            const totalMale = items.filter((item) => item.volunteer_sex === 'ชาย').length;
            const totalFemale = items.filter((item) => item.volunteer_sex === 'หญิง').length;
            const totalRegular = items.filter((item) => item.work_status === 'ปฏิบัติงานประจำ').length;
            const totalIrregular = items.filter((item) => item.work_status === 'ปฏิบัติงานไม่ประจำ').length;
            const totalDisasterRelief = items.filter((item) => item.volunteer_skill.includes('บรรเทาสาธารณภัย')).length;
            const totalSecurity = items.filter((item) => item.volunteer_skill.includes('เผชิญเหตุ')).length;
            const totalAid = items.filter((item) => item.volunteer_skill.includes('สงเคราะห์ผู้ประสบภัย')).length;
            const totalRescue = items.filter((item) => item.volunteer_skill.includes('ปฏิบัติการกู้ชีพกู้ภัย')).length;
            const totalOther = items.filter((item) => item.volunteer_skill.includes('อื่นๆ')).length;

            const summaryRow = [
                'รวม',
                '',
                '',
                totalMale,
                totalFemale,
                totalRegular,
                totalIrregular,
                totalDisasterRelief,
                totalSecurity,
                totalAid,
                totalRescue,
                totalOther,
                ''
            ];

            return [...headers, ...rows, summaryRow];
        },
        acceptNumberPhone() {
            var x = this.volunteer_tel.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.volunteer_tel = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        generateVolunteerId() {
            const timestamp = Date.now().toString(36); // Convert timestamp to base-36 string
            const randomComponent = Math.random().toString(36).substring(2, 10); // Generate a random base-36 string
            return `vol-${timestamp}-${randomComponent}`;
        },

        calculateAge(birthDate) {
            const formattedBirthDate = this.formatDate(birthDate);
            const birth = new Date(formattedBirthDate.split('/').reverse().join('-'));
            const today = new Date();
            let age = today.getFullYear() - birth.getFullYear();
            const monthDiff = today.getMonth() - birth.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
                age--;
            }
            return age;
        },

        formatDate(inputDate) {
            const date = new Date(inputDate);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },

        clearAllCourse() {
            if (this.course_history_list.length > 1) {
                this.course_history_list = [this.course_history_list[0]];
            }
        },

        async fetchFireStations() {
            try {
                const response = await axios.post(`${this.$url_service}/get/fire/station`);
                if (response.data.code === 'success') {
                    this.FireStationOptions_AT = response.data.data;
                } else {
                    console.error('Error fetching fire stations:', response.data);
                }
            } catch (error) {
                console.error('Server error:', error);
            }
        },

        async Fire_Form() {
            if (this.selectedData == '') {
                this.ifh_FireStationSelected = null;
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser(),
                        province_id:
                            this.ifh_selectedProvince == null
                                ? ''
                                : this.ifh_selectedProvince.province_id == 'getall'
                                ? ''
                                : this.ifh_selectedProvince.province_id,
                        amphur_id:
                            this.ira_selectedAmphur == null
                                ? ''
                                : this.ira_selectedAmphur.amphur_id == 'getall'
                                ? ''
                                : this.ira_selectedAmphur.amphur_id,
                        tambon_id:
                            this.ira_selectedTambon == null
                                ? ''
                                : this.ira_selectedTambon.tambon_id == 'getall'
                                ? ''
                                : this.ira_selectedTambon.tambon_id
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;

                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        async searchManInfo() {
            if (this.organize_table.length === 0) {
                this.$fire({
                    title: 'กรุณาเลือกหน่วยงานที่ต้องการค้นหา',
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
                return;
            }

            this.loading = true;

            const { volunteer_fullname, workStatus_search, volunteerProfessional_search, baseOperation_search } = this.searchCriteria;

            const organizeArray = this.organize_table.map((item) => item.fs_tname);
            const fs_tname = organizeArray.length > 0 ? organizeArray : [];

            try {
                let response;
                const userId = this.getUsername();

                response = await this.axios.post(`${this.$url_service}/search/volunteer-bangkok?user=${userId}`, {
                    organize: fs_tname,
                    volunteer_fullname: volunteer_fullname || '',
                    workStatus_search: workStatus_search?.system_name || '',
                    volunteerProfessional_search: volunteerProfessional_search?.system_name || '',
                    baseOperation_search: baseOperation_search?.system_name || ''
                });

                if (response.data && Array.isArray(response.data.data)) {
                    this.manInfo_Table = response.data.data;
                    this.cloneTable = response.data.data;
                    this.items = response.data.data;
                    this.formatManInfoTable();
                    this.setSearchText_Footer();

                    // console.log('items', this.items);
                } else {
                    console.error('Unexpected Response Data:', response.data);
                    this.manInfo_Table = [];
                }
            } catch (error) {
                console.error('Error in searchManInfo:', error);
            }

            this.loading = false;
        },

        formatManInfoTable() {
            for (let index = 0; index < this.manInfo_Table.length; index++) {
                const element = this.manInfo_Table[index].specialist_id;
                if (element === '[]' || element === []) {
                    this.manInfo_Table[index].specialist_id = '-';
                } else {
                    try {
                        let dataGetSpecial = JSON.parse(this.manInfo_Table[index].specialist_id);
                        let specialistNameData = '';
                        for (let i = 0; i < dataGetSpecial.length; i++) {
                            const elementSpecial = dataGetSpecial[i].system_name;
                            specialistNameData += `${elementSpecial} `;
                        }
                        this.manInfo_Table[index].specialist_id = specialistNameData;
                    } catch (jsonError) {
                        console.error('JSON Parse Error:', jsonError);
                        this.manInfo_Table[index].specialist_id = '-';
                    }
                }
            }

            for (let i = 0; i < this.manInfo_Table.length; i++) {
                this.manInfo_Table[i]['index'] = i + 1;
            }

            this.formatData(this.manInfo_Table);
        },

        clearVolunteerReferalPerson() {
            this.volunteer_prefix_name_referal = null;
            this.referal_firstname = '';
            this.referal_lastname = '';
            this.referal_position = '';
            this.volunteerReferalTableData = [];
            this.error_volunteer_prefix_name = false;
            this.error_courseSelected = false;
        },
        clearVolunteerEducation() {
            this.volunteer_education_name = '';
            this.volunteer_education_level = null;
            this.volunteer_education_degree = '';
            this.volunteer_education_major = '';
            this.volunteer_education_info = '';
            this.VolunteerEducationTableData = [];
            this.error_courseSelected = false;
        },

        clearVolunteerParentsDataTable() {
            this.volunteer_prefix_name_parents = null;
            this.volunteer_parents_firstname = '';
            this.volunteer_parents_lastname = '';

            this.VolunteerParentsTableData.splice(0, this.VolunteerParentsTableData.length);
        },

        validateIdCard(event) {
            // Remove any non-digit characters
            this.volunteer_id_card = event.target.value.replace(/\D/g, '');
        },
        allowOnlyIntegers(event) {
            // Allow only integer input
            let charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        },

        async updateVolunteerDataDetail() {
            try {
                // Set loading state to true
                this.loadingCreate = true;

                // Prepare the payload to send to the backend
                const volunteerDetail = {
                    currentVolunteerId: this.volunteer_id || '', // Ensure ID exists
                    volunteer_prefix_name: this.volunteer_prefix_name?.system_name || '', // Use system_name if it exists
                    volunteer_sex: this.volunteerSex?.system_name || '',
                    volunteer_firstname: this.volunteer_firstname || '',
                    volunteer_lastname: this.volunteer_lastname || '',
                    volunteer_birth_date: this.volunteer_birth_date ? new Date(this.volunteer_birth_date).toISOString().split('T')[0] : '', // Format date correctly
                    volunteer_age: this.volunteer_age || '',
                    volunteer_id_card: this.volunteer_id_card || '',
                    volunteer_tel: this.volunteer_tel || '',
                    FireStationSelected: this.FireStationSelected?.fs_tname || '', // Use the fs_tname if available
                    volunteer_local_address: this.volunteer_local_address || '',
                    volunteer_current_address: this.volunteer_current_address || '',
                    volunteer_education_name: this.volunteer_education_name || '',
                    volunteer_education_level: this.volunteer_education_level?.system_name || '', // Use system_name from dropdown
                    volunteer_education_degree: this.volunteer_education_degree || '',
                    volunteer_education_major: this.volunteer_education_major || '',
                    volunteer_education_info: this.volunteer_education_info || '',
                    course_history: this.course_history_list.map((course) => course.course_name),
                    volunteerSkill: this.volunteerSkill?.system_name || '', // Use system_name for skill
                    volunteerProfessional: this.volunteerProfessional?.system_name || '', // Use system_name for professional
                    workStatus: this.workStatus?.system_name || '', // Use system_name for work status
                    baseOperation: this.baseOperation?.system_name || '', // Use system_name for base operation
                    volunteer_job: this.volunteer_job || '',
                    date_updated: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
                    updated_by: this.getUsername_userName() || '',
                    other_skill: this.otherSkill || '',
                    other_professional: this.otherProfessional || '',
                    other_base_operation: this.otherBaseOperation || '',
                    volunteer_image: this.imp_uploadImageFile || ''
                };

                // Log the payload for debugging
                // console.log('Posting volunteer data:', volunteerDetail);

                const userId = this.getUsername();

                // Send the POST request with Axios
                const response = await axios.post(`${this.$url_service}/update/volunteer-bangkok/detail?user=${userId}`, {
                    volunteerData: volunteerDetail
                });

                // Handle success response
                if (response.status === 200) {
                    // console.log('Volunteer detail updated successfully:', response.data);
                    this.$fire({
                        title: 'สำเร็จ',
                        text: 'ข้อมูลถูกอัปเดตเรียบร้อยแล้ว!',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    }).then(() => {
                        this.manInfoModal = false; // Close modal after confirmation
                    });
                }
            } catch (error) {
                // Handle error response
                console.error('Error updating volunteer detail:', error);
                this.$fire({
                    title: 'ข้อผิดพลาด',
                    text: 'มีข้อผิดพลาดในการอัปเดตข้อมูล: ' + error.message,
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            } finally {
                // Reset loading state
                this.loadingCreate = false;
            }
        },

        getDisasterNames(disasterId) {
            if (!disasterId) return '';

            try {
                const disasterArray = JSON.parse(disasterId);
                return disasterArray.map((disaster) => disaster.system_name).join(', ');
            } catch (e) {
                console.error('Failed to parse disaster_id:', e);
                return '';
            }
        },
        getTrainingHistoryName(trainingId) {
            if (!trainingId) return '';

            try {
                const trainingArray = JSON.parse(trainingId);
                return trainingArray.map((training) => training.course_name).join(', ');
            } catch (e) {
                console.error('Failed to parse training_id:', e);
                return '';
            }
        },
        formatThaiDate(date) {
            if (!date) return null;
            const thaiMonths = [
                'มกราคม',
                'กุมภาพันธ์',
                'มีนาคม',
                'เมษายน',
                'พฤษภาคม',
                'มิถุนายน',
                'กรกฎาคม',
                'สิงหาคม',
                'กันยายน',
                'ตุลาคม',
                'พฤศจิกายน',
                'ธันวาคม'
            ];
            const d = new Date(date);
            const day = d.getDate();
            const month = thaiMonths[d.getMonth()];
            const year = d.getFullYear() + 543; // Convert to Thai Buddhist year
            return `${day} ${month} ${year}`;
        },

        async saveVolunteerDataDetail() {
            this.isEditMode = true;

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}`;
            }

            const volunteerImage = this.imp_uploadImageFile || '';
            const currentDateString = formatDate(new Date());

            // Validation for all required fields
            let hasError = false;
            if (!this.volunteer_prefix_name) {
                this.error_volunteer_prefix_name = true;
                hasError = true;
            } else {
                this.error_volunteer_prefix_name = false;
            }
            if (!this.volunteer_firstname) {
                this.error_volunteer_firstname = true;
                hasError = true;
            } else {
                this.error_volunteer_firstname = false;
            }
            if (!this.volunteer_lastname) {
                this.error_volunteer_lastname = true;
                hasError = true;
            } else {
                this.error_volunteer_lastname = false;
            }
            if (!this.volunteer_birth_date) {
                this.error_volunteer_birth_date = true;
                hasError = true;
            } else {
                this.error_volunteer_birth_date = false;
            }
            if (!this.volunteer_id_card || this.volunteer_id_card.length !== 13) {
                this.error_volunteer_id_card = true;
                hasError = true;
            } else {
                this.error_volunteer_id_card = false;
            }
            if (!this.volunteer_birth_date) {
                this.error_volunteer_birth_date = true;
                hasError = true;
            } else {
                this.error_volunteer_birth_date = false;
            }

            if (!this.volunteer_tel) {
                this.error_volunteer_tel = true;
                hasError = true;
            } else {
                this.error_volunteer_tel = false;
            }

            if (!this.FireStationSelected) {
                this.error_fire_station = true;
                hasError = true;
            } else {
                this.error_fire_station = false;
            }

            // If any required field has an error, return and do not proceed
            if (hasError) {
                return;
            }

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const username = this.decodeToken.user_username;
                        const userId = this.getUsername();
                        // const officerOrganizeId = this.volunteer_organize?.id || '';

                        const volunteerDetail = {
                            volunteer_id: this.generateVolunteerId(),
                            prefix_name: this.volunteer_prefix_name.system_name,
                            volunteerSex: this.volunteerSex.system_name,
                            volunteer_firstname: this.volunteer_firstname,
                            volunteer_lastname: this.volunteer_lastname,
                            birth_date: this.volunteer_birth_date,
                            volunteer_age: this.volunteer_age,
                            volunteer_id_card: this.volunteer_id_card,
                            volunteer_tel: this.volunteer_tel,
                            volunteer_job: this.volunteer_job,
                            fs_tname: this.FireStationSelected.fs_tname,
                            volunteer_local_address: this.volunteer_local_address,
                            volunteer_current_address: this.volunteer_current_address,
                            volunteer_education_level: this.volunteer_education_level.system_name,
                            course_history: this.course_history_list.map((course) => course.course_name),
                            volunteer_skill: this.volunteerSkill.system_name,
                            volunteer_professional: this.volunteerProfessional.system_name,
                            work_status: this.workStatus.system_name,
                            base_operation: this.baseOperation.system_name,
                            otherSkill: this.otherSkill,
                            otherProfessional: this.otherProfessional,
                            otherBaseOperation: this.otherBaseOperation,
                            created_by: username,
                            updated_by: username,
                            date_created: currentDateString,
                            date_updated: currentDateString,
                            flag: 1,
                            volunteer_image: volunteerImage
                        };

                        const payload = {
                            volunteerDetail
                        };

                        // console.log('volunteer_id', this.volunteer_id);
                        this.loadingCreate = true;
                        const response = await fetch(`${this.$url_service}/post/volunteer-bangkok/detail?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            throw new Error(`Network response was not ok: ${response.statusText}`);
                        }

                        const data = await response.json();
                        // console.log('Volunteer detail posted successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.manInfoModal = false;
                        });
                    } catch (error) {
                        console.error('Error posting volunteer detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        saveData_Modal() {
            // เรียกใช้ฟังก์ชัน update หรือ save ตามสถานการณ์
            if (this.isEditMode) {
                this.updateVolunteerDataDetail();
            } else {
                this.saveVolunteerDataDetail(); // ควรมีฟังก์ชันสำหรับสร้างข้อมูลใหม่
            }
        },

        exportCSV() {
            this.$nextTick(() => {
                if (this.$refs.dt) {
                    this.$refs.dt.exportCSV();
                } else {
                    console.error('DataTable ref is not available');
                }
            });
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: { topic: 'get-option' }
                })
                .then((response) => {
                    (this.courseOptions = response.data.data),
                        this.courseOptions.splice(0, 0, {
                            course_id: 'getall',
                            course_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-08' }
                })
                .then((response) => {
                    (this.levelOptions = response.data.data),
                        this.levelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
        },

        search() {
            if (this.filter !== '' && this.cloneTable.length > 0) {
                const searchTerm = this.filter.toLowerCase();

                this.manInfo_Table = this.cloneTable.filter((item) => {
                    return Object.keys(item).some((key) => {
                        let value = item[key];
                        if (key === 'birth_date' || key === 'date_created' || key === 'date_updated') {
                            value = this.formatThaiDate(value);
                        }
                        return value && value.toString().toLowerCase().includes(searchTerm);
                    });
                });

                // Update the index
                this.manInfo_Table.forEach((item, index) => {
                    item['index'] = index + 1;
                });
            } else {
                this.manInfo_Table = [...this.cloneTable];
                this.manInfo_Table.forEach((item, index) => {
                    item['index'] = index + 1;
                });
            }
        },
        async initialData() {
            this.clearSearchField();
            this.MobileClearSearchField();
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-08' }
                })
                .then((response) => {
                    (this.levelOptions = response.data.data),
                        this.levelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            if (this.columns_disabled == true) {
                this.manInfo_Table = this.cloneTable;
            } else {
                this.manInfo_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: { topic: 'get-option' }
                })
                .then((response) => {
                    (this.courseOptions = response.data.data),
                        this.courseOptions.splice(0, 0, {
                            course_id: 'getall',
                            course_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].base_operation == null || data[index].base_operation == 'null' || data[index].base_operation == '') {
                    data[index].base_operation = '-';
                }
                if (data[index].work_status == null || data[index].work_status == 'null' || data[index].work_status == '') {
                    data[index].work_status = '-';
                }
                if (data[index].specialist_id == null || data[index].specialist_id == 'null' || data[index].specialist_id == '') {
                    data[index].specialist_id = '-';
                }
                if (
                    data[index].officer_response_signal == null ||
                    data[index].officer_response_signal == 'null' ||
                    data[index].officer_response_signal == ''
                ) {
                    data[index].officer_response_signal = '-';
                }
                if (
                    data[index].officer_mobile_phone == null ||
                    data[index].officer_mobile_phone == 'null' ||
                    data[index].officer_mobile_phone == ''
                ) {
                    data[index].officer_mobile_phone = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },

        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        acceptNumberPhone_4() {
            var x = this.volunteer_secretary_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.volunteer_secretary_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.clearData();
            this.manInfoModal = false;
            this.displayConfirmationCloseModal = false;
        },

        clearImage() {
            this.url = null;
            document.getElementById('imp_uploadImageFile').value = '';
        },

        onFileChange(e) {
            document.getElementById('imp_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    if (e.target.files[0].type.split('/')[0] === 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                this.imp_uploadImageFile = dataurl; // Store base64 image data
                            };

                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('imp_uploadImageFile').value = '';
                    }
                } else {
                    this.url = null;
                }
            }
        },

        selectedOrganize_passValue_Form(decodedToken) {
            this.showOrganize_Form = false;
            if (this.manInfoModal == false) {
                this.selectedOrganize = {
                    id: decodedToken.organize_id,
                    name: decodedToken.organize_name
                };
            } else {
                this.volunteer_organize = {
                    id: decodedToken.organize_id,
                    name: decodedToken.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(decodedToken) {
            this.showOrganize = false;
            if (decodedToken != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < decodedToken.length; i++) {
                        this.organize_table.push({
                            organize_id: decodedToken[i].organize_id,
                            fs_tname: decodedToken[i].fs_tname
                        });
                    }
                }
            }
        },

        async searchCourse() {
            if (this.volunteer_course_name == null) {
                this.error_courseSelected = true;
            } else {
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: {
                            topic: 'search-history-table',
                            course_name: this.volunteer_course_name.course_name,
                            level: this.courseLevelSelected
                        }
                    })
                    .then((response) => (this.trainingCourse_Table = response.data.data));
            }
        },

        // setSearchText_Footer() {
        //     this.text_Footer = false;
        //     this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
        //     if (
        //         this.organize_table.length !== 0 ||
        //         this.volunteer_fullname !== ''
        //     ) {
        //         for (let index = 0; index < this.Data_text_Footer.length; index++) {
        //             const element = this.Data_text_Footer[index];
        //             if (element.DataName === 'หน่วยงาน' && this.organize_table.length !== 0) {
        //                 element.textShow = this.setAll_organize_table(this.organize_table);
        //             }
        //             if (element.DataName === 'ชื่อ-นามสกุล' && this.volunteer_fullname !== '') {
        //                 element.textShow = this.volunteer_fullname;
        //             }

        //         }
        //         this.text_Footer = true;
        //     }
        // },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.organize_table.length !== 0 || this.searchCriteria.volunteer_fullname !== '') {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงาน' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อ-นามสกุล' && this.searchCriteria.volunteer_fullname !== '') {
                        element.textShow = this.searchCriteria.volunteer_fullname;
                    }
                }
                this.text_Footer = true;
            }
        },

        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.fs_tname !== undefined) {
                    text += element.fs_tname + ',';
                }
            }
            return text.slice(0, -1);
        },
        check_selectedGenDate(data) {
            if (data.value === 'date') {
                return this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.searchby)), 'string');
            } else {
                return this.searchby;
            }
        },
        checkNull_String(info) {
            if (info !== null && info !== '') {
                return true;
            } else {
                return false;
            }
        },
        addCourse() {
            this.showCourseHistory = false;
            this.history_table = [];
            for (let i = 0; i < this.selectedTrainingData.length; i++) {
                this.history_table.push({
                    course_id: this.selectedTrainingData[i].course_id,
                    course_name: this.selectedTrainingData[i].course_name,
                    course_level: this.selectedTrainingData[i].course_level,
                    gen: this.selectedTrainingData[i].gen,
                    start_date: this.selectedTrainingData[i].start_date,
                    end_date: this.selectedTrainingData[i].end_date,
                    remark: this.selectedTrainingData[i].remark
                });
            }
        },

        async confirmDelete() {
            if (this.deleteAt === 'special-table') {
                this.special_table = this.special_table.filter((val) => val !== this.specialDelete);
                this.displayConfirmation = false;
                this.volunteer_special = this.special_table;
            } else if (this.deleteTable == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else if (this.deleteAt === 'history-table') {
                this.history_table = this.history_table.filter((val) => val !== this.historyDelete);
                this.displayConfirmation = false;
            } else {
                try {
                    const userId = this.getUsername();
                    await this.axios.post(`${this.$url_service}/delete/volunteer-bangkok/detail?user=${userId}`, {
                        volunteer_id: this.temp
                    });

                    this.$fire({
                        type: 'success',
                        title: 'ลบข้อมูลสำเร็จ',
                        text: 'ข้อมูลอาสาสมัคร',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });

                    this.searchManInfo(); // Refresh the table data
                } catch (error) {
                    console.error('Error deleting volunteer_id:', error);
                    this.$fire({
                        type: 'error',
                        title: 'ลบข้อมูลล้มเหลว',
                        text: 'ไม่สามารถลบข้อมูลได้',
                        timer: 3000,
                        confirmButtonColor: '#E74C3C'
                    });
                } finally {
                    this.displayConfirmation = false;
                }
            }
        },

        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },

        async saveData() {
            this.isEditMode = true;

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}`;
            }

            const currentDateString = formatDate(new Date());

            // Validation for all required fields
            let hasError = false;
            if (!this.volunteer_prefix_name) {
                this.error_volunteer_prefix_name = true;
                hasError = true;
            } else {
                this.error_volunteer_prefix_name = false;
            }
            if (!this.volunteer_firstname) {
                this.error_volunteer_firstname = true;
                hasError = true;
            } else {
                this.error_volunteer_firstname = false;
            }
            if (!this.volunteer_lastname) {
                this.error_volunteer_lastname = true;
                hasError = true;
            } else {
                this.error_volunteer_lastname = false;
            }
            if (!this.volunteer_start_workDate) {
                this.error_volunteer_start_workDate = true;
                hasError = true;
            } else {
                this.error_volunteer_start_workDate = false;
            }
            if (!this.volunteer_id_card || this.volunteer_id_card.length !== 13) {
                this.error_volunteer_id_card = true;
                hasError = true;
            } else {
                this.error_volunteer_id_card = false;
            }
            if (!this.volunteer_birth_date) {
                this.error_volunteer_birth_date = true;
                hasError = true;
            } else {
                this.error_volunteer_birth_date = false;
            }
            if (!this.volunteer_tel) {
                this.error_volunteer_tel = true;
                hasError = true;
            } else {
                this.error_volunteer_tel = false;
            }
            if (!this.volunteer_level) {
                this.error_volunteer_level = true;
                hasError = true;
            } else {
                this.error_volunteer_level = false;
            }
            if (!this.volunteer_position) {
                this.error_volunteer_position = true;
                hasError = true;
            } else {
                this.error_volunteer_position = false;
            }

            // If any required field has an error, return and do not proceed
            if (hasError) {
                return;
            }

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const username = this.decodeJWT.user_username;
                        const officerOrganizeId = this.volunteer_organize?.id || '';

                        const volunteerDetail = {
                            volunteer_id: this.selectedData.volunteer_id,
                            volunteer_image: this.url,
                            officer_prefix: this.volunteer_prefix_name.system_id,
                            volunteer_firstname: this.volunteer_firstname,
                            volunteer_lastname: this.volunteer_lastname,
                            officer_birthdate: formatDate(this.volunteer_birth_date),
                            officer_startwork: formatDate(this.volunteer_start_workDate),
                            officer_mobile_phone: this.volunteer_mobile_phone_number,
                            officer_position: this.volunteer_position,
                            officer_level_id: this.volunteer_level?.system_id,
                            officer_organize: officerOrganizeId,
                            specialist_id: JSON.stringify(this.special_table),
                            disaster_id: JSON.stringify(this.disaster_table),
                            training_history_table: JSON.stringify(this.history_table),
                            date_update: currentDateString,
                            updated_by: username,
                            flag: 'active',
                            volunteer_id_card: this.volunteer_id_card || '',
                            editor: username
                        };

                        const volunteerLocalAddress = {
                            address_no: this.localAddressTableData[0]?.address_no || '',
                            address_village: this.localAddressTableData[0]?.address_village || '',
                            address_alley: this.localAddressTableData[0]?.address_alley || '',
                            address_road: this.localAddressTableData[0]?.address_road || '',
                            address_sub_district: this.localAddressTableData[0]?.sub_district || '',
                            address_district: this.localAddressTableData[0]?.district || '',
                            address_province: this.localAddressTableData[0]?.province || '',
                            address_more_info: this.localAddressTableData[0]?.more_info || '',
                            date_update: currentDateString,
                            updated_by: username,
                            flag: 'active'
                        };

                        const volunteerCurrentAddress = {
                            address_no: this.currentAddressTableData[0]?.address_no || '',
                            address_village: this.currentAddressTableData[0]?.address_village || '',
                            address_alley: this.currentAddressTableData[0]?.address_alley || '',
                            address_road: this.currentAddressTableData[0]?.address_road || '',
                            address_sub_district: this.currentAddressTableData[0]?.sub_district || '',
                            address_district: this.currentAddressTableData[0]?.district || '',
                            address_province: this.currentAddressTableData[0]?.province || '',
                            address_more_info: this.currentAddressTableData[0]?.more_info || '',
                            date_update: currentDateString,
                            updated_by: username,
                            flag: 'active'
                        };

                        const volunteerParents = [
                            {
                                parents_prefix: this.VolunteerParentsTableData.parents_prefix || '',
                                parents_firstname: this.VolunteerParentsTableData.parents_firstname || '',
                                parents_lastname: this.VolunteerParentsTableData.parents_lastname || '',
                                date_update: currentDateString,
                                updated_by: username,
                                flag: 'active'
                            }
                        ];

                        const volunteerReferalPerson = [
                            {
                                referal_prefix: this.volunteerReferalTableData.referal_prefix || '',
                                referal_firstname: this.volunteerReferalTableData.referal_firstname || '',
                                referal_lastname: this.volunteerReferalTableData.referal_lastname || '',
                                referal_position: this.volunteerReferalTableData.referal_position || '',
                                date_update: currentDateString,
                                updated_by: username,
                                flag: 'active'
                            }
                        ];

                        const volunteerEducation = [
                            {
                                education_name: this.VolunteerEducationTableData.education_name || '',
                                education_level: this.VolunteerEducationTableData.education_level || '',
                                education_degree: this.VolunteerEducationTableData.education_degree || '',
                                education_major: this.VolunteerEducationTableData.education_major || '',
                                date_update: currentDateString,
                                updated_by: username,
                                flag: 'active'
                            }
                        ];

                        const payload = {
                            volunteerData: volunteerDetail,
                            volunteerLocalAddress,
                            volunteerCurrentAddress,
                            volunteerParents,
                            volunteerReferalPerson,
                            volunteerEducation
                        };

                        this.loadingCreate = true;

                        const response = await fetch(`${this.$url_service}/update/volunteer/detail`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        });
                    } catch (error) {
                        console.error('Error posting volunteer detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        formatDateTH(time) {
            let dateNew;
            for (let i = 0; i < time.length; i++) {
                const element = time.split('/');
                dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
            }
            return moment(dateNew).locale('th').add(543, 'year').format('DD/MM/YYYY');
        },

        async editData(volunteer_id) {
            // console.log('Edit mode activated for volunteer_id:', volunteer_id);
            this.isEditMode = true;
            this.header = this.$i18n.t('แก้ไขข้อมูลอาสาสมัครในพื้นที่กรุงเทพมหานคร');

            this.volunteer_id = volunteer_id;
            // console.log('Fetching volunteer data for volunteer_id:', volunteer_id);

            try {
                const response = await this.axios.post(`${this.$url_service}/search/update/volunteer-bangkok/detail`, {
                    volunteer_id: volunteer_id
                });

                // console.log('API response received:', response);

                if (response.data && response.data.data && response.data.data.length > 0) {
                    const data = response.data.data[0];
                    // console.log('Data found:', data);

                    // Populate the form with the retrieved data
                    this.selectedData = data;
                    this.volunteer_id = data.volunteer_id || '';
                    this.volunteer_prefix_name = {
                        system_id: data.officer_prefix,
                        system_name: data.prefix_name
                    };
                    this.volunteerSex = {
                        system_name: data.volunteer_sex,
                        value: data.volunteer_sex
                    };
                    this.volunteer_firstname = data.volunteer_firstname || '';
                    this.volunteer_lastname = data.volunteer_lastname || '';
                    this.volunteer_birth_date = this.formatDate(data.birth_date) || '';
                    this.volunteer_age = data.volunteer_age || '';
                    this.volunteer_id_card = data.volunteer_id_card || '';
                    this.volunteer_tel = data.volunteer_tel || '';
                    this.volunteer_job = data.volunteer_job || '';
                    this.FireStationSelected = {
                        fs_tname: data.fs_tname
                    };

                    this.date_create_form = this.formatDate(data.date_created) || '';
                    this.date_update_form = this.formatDate(data.date_updated) || '';
                    this.url = data.volunteer_image || '';
                    this.imp_uploadImageFile = data.volunteer_image || '';

                    this.volunteer_local_address = data.volunteer_local_address || '';
                    this.volunteer_current_address = data.volunteer_current_address || '';
                    this.volunteer_education_name = data.volunteer_education_name || '';
                    this.volunteer_education_level = {
                        system_name: data.volunteer_education_level
                    };
                    this.volunteer_education_degree = data.volunteer_education_degree || '';
                    this.volunteer_education_major = data.volunteer_education_major || '';
                    this.volunteer_education_info = data.volunteer_education_info || '';
                    // this.course_history_list = data.course_history ? data.course_history.split(',') : [];
                    this.course_history_list = data.course_history ? data.course_history.split(',').map((course) => ({ course_name: course })) : [];
                    this.volunteerSkill = {
                        system_name: data.volunteer_skill
                    };
                    this.volunteerProfessional = {
                        system_name: data.volunteer_professional
                    };
                    this.workStatus = {
                        system_name: data.work_status
                    };
                    this.baseOperation = {
                        system_name: data.base_operation
                    };
                    this.otherSkill = data.other_skill || '';
                    this.otherProfessional = data.other_professional || '';

                    // Remove existing focus
                    document.activeElement.blur();

                    // Set focus to the first input field
                    this.$nextTick(() => {
                        if (this.$refs.TextBox_1) {
                            this.$refs.TextBox_1.focus();
                        }
                    });
                } else {
                    console.error('No data found for the given volunteer_id:', volunteer_id);
                }
            } catch (error) {
                console.error('Error fetching volunteer data:', error);
            }
        },

        addCourseHistory() {
            this.course_history_list.push({ course_name: '' });
        },
        removeCourseHistory(index) {
            this.course_history_list.splice(index, 1);
        },

        //old
        // addCourseHistory() {
        //     this.course_history_list.push({ name: '', level: '' });
        // },

        // removeCourseHistory(index) {
        //     if (this.course_history_list.length > 1) {
        //         this.course_history_list.splice(index, 1);
        //     } else if (this.course_history_list.length == 1) {
        //         this.course.course_name = '';
        //     }
        // },

        clearData() {
            // ฟังก์ชันรีเซ็ตข้อมูลภายใน modal
            this.volunteer_prefix_name = null;
            this.imp_uploadImageFile = '';
            this.volunteer_sex = '';
            this.volunteer_firstname = '';
            this.volunteer_lastname = '';
            this.volunteer_birth_date = null;
            this.volunteer_age = '';
            this.volunteer_id_card = '';
            this.volunteer_tel = '';
            this.FireStationSelected = '';
            this.volunteer_local_address = '';
            this.volunteer_current_address = '';
            this.volunteer_education_name = '';
            this.volunteer_education_level = null;
            this.volunteer_education_degree = '';
            this.volunteer_education_major = '';
            this.volunteer_education_info = '';
            this.course.course_name = '';
            this.volunteerSkill = null;
            this.volunteerProfessional = null;
            this.workStatus = null;
            this.baseOperation = null;
            this.error_volunteer_prefix_name = false;
            this.error_volunteer_firstname = false;
            this.error_volunteer_lastname = false;
            this.error_volunteer_birth_date = false;
            this.error_volunteer_id_card = false;
            this.error_volunteer_tel = false;
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.volunteer_prefix_name = null;
            this.volunteerSex = null;
            this.volunteer_firstname = '';
            this.volunteer_lastname = '';
            this.url = null;
            const uploadImageFileElement = document.getElementById('volunteer_uploadImageFile');
            if (uploadImageFileElement) {
                uploadImageFileElement.value = '';
            }
            this.volunteer_birth_date = null;
            this.volunteer_age = '';
            this.volunteer_id_card = '';
            this.volunteer_tel = '';
            this.volunteer_job = '';
            this.FireStationSelected = null;
            this.error_fire_station = false;
            this.volunteer_local_address = '';
            this.volunteer_current_address = '';
            this.volunteer_education_level = null;
            this.course = { course_name: '' };
            this.volunteerSkill = null;
            this.otherSkill = '';
            this.volunteerProfessional = null;
            this.otherProfessional = '';
            this.workStatus = null;
            this.baseOperation = null;
            this.otherBaseOperation = '';
            this.volunteer_organize = {};
            this.course_history_list = [{ course_name: '' }];

            this.error_volunteer_prefix_name = false;
            this.error_volunteer_firstname = false;
            this.error_volunteer_lastname = false;
            this.error_volunteer_organize = false;
            this.error_volunteer_start_workDate = false;
            this.error_volunteer_level = false;
            this.error_email_format = false;

            this.error_volunteer_prefix_name = false;
            this.error_volunteer_firstname = false;
            this.error_volunteer_lastname = false;
            this.error_volunteer_birth_date = false;
            this.error_volunteer_id_card = false;
            this.error_volunteer_tel = false;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.date_create_form = '';
            this.date_update_form = '';
            this.fireStation = null;
            this.error_fireStation = false;
        },

        async clearSearchField() {
            // Clear search input fields
            this.searchCriteria.volunteer_fullname = '';
            this.searchCriteria.volunteer_level_id = null;
            this.searchCriteria.training_history = '';
            this.searchCriteria.updatedDate = '';
            this.searchCriteria.check_update_info = [];
            this.searchCriteria.organize_id = null;
            this.searchCriteria.workStatus_search = null;
            this.searchCriteria.baseOperation_search = null;
            this.searchCriteria.volunteerProfessional_search = null;

            // Clear DataTables
            this.manInfo_Table = [];
            this.cloneTable = [];
            this.organize_table = [];
            this.selectedOrganizeData = [];

            // Reset any error states if needed
            this.error_volunteer_fullname = false;
            this.error_volunteer_level_id = false;
            this.error_volunteer_professional = false;
            this.error_training_history = false;
            this.error_updatedDate = false;
            this.error_check_update_info = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
            this.fireStation = null;
        },

        // Function to clear search fields and DataTable for mobile view
        async MobileClearSearchField() {
            // Clear search input fields
            this.searchCriteria.volunteer_fullname = '';
            this.searchCriteria.volunteer_level_id = null;
            this.searchCriteria.volunteer_professional = '';
            this.searchCriteria.training_history = '';
            this.searchCriteria.updatedDate = '';
            this.searchCriteria.check_update_info = [];
            this.searchCriteria.organize_id = null;
            this.searchCriteria.workStatus_search = null;
            this.searchCriteria.baseOperation_search = null;
            this.searchCriteria.volunteerProfessional_search = null;

            // Clear DataTables
            this.manInfo_Table = [];
            this.cloneTable = [];
            this.organize_table = [];
            this.selectedOrganizeData = [];

            // Reset any error states if needed
            this.error_volunteer_fullname = false;
            this.error_volunteer_level_id = false;
            this.error_volunteer_professional = false;
            this.error_training_history = false;
            this.error_updatedDate = false;
            this.error_check_update_info = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
        },

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log("deleteAt",deleteAt)
                    // console.log("temp",temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 130;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 7) {
                this.PDF_minCellWidthVer = 80;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 9) {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    volunteer_fullname: { cellWidth: 55 },
                    work_status: { cellWidth: 45 },
                    // organize_name:{cellWidth:60},
                    specialist_id: { cellWidth: 40 },
                    officer_response_signal: { cellWidth: 45 },

                    text_tel_detail: { cellWidth: 60 },

                    user_fullname: { cellWidth: 45 },
                    date_update_ddmmyy: { cellWidth: 65 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },

                    work_status: { cellWidth: 50 },
                    organize_name: { cellWidth: 75 },
                    specialist_id: { cellWidth: 70 },
                    officer_response_signal: { cellWidth: 55 },

                    text_tel_detail: { cellWidth: 60 },

                    user_fullname: { cellWidth: 50 }
                };
            } else {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_volunteer_fullname = false;
                this.columns_base_operation = false;
                this.columns_work_status = false;
                this.columns_organize_name = false;
                this.columns_specialist_id = false;
                this.columns_officer_response_signal = false;
                this.columns_officer_mobile_phone = false;
                // this.columns_update_date = false
                this.columns_user_fullname = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'volunteer_image') {
                        this.columns_img = true;
                    } else if (!getData.includes('volunteer_image')) {
                        this.columns_img = false;
                    }

                    if (element == 'volunteer_fullname') {
                        this.columns_volunteer_fullname = true;
                    } else if (!getData.includes('volunteer_fullname')) {
                        this.columns_volunteer_fullname = false;
                    }

                    if (element == 'base_operation') {
                        this.columns_base_operation = true;
                    } else if (!getData.includes('base_operation')) {
                        this.columns_base_operation = false;
                    }

                    if (element == 'work_status') {
                        this.columns_work_status = true;
                    } else if (!getData.includes('work_status')) {
                        this.columns_work_status = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'specialist_id') {
                        this.columns_specialist_id = true;
                    } else if (!getData.includes('specialist_id')) {
                        this.columns_specialist_id = false;
                    }

                    if (element == 'officer_response_signal') {
                        this.columns_officer_response_signal = true;
                    } else if (!getData.includes('officer_response_signal')) {
                        this.columns_officer_response_signal = false;
                    }

                    // if (element == "officer_mobile_phone") {
                    //   this.columns_officer_mobile_phone = true
                    // }else if(!getData.includes("officer_mobile_phone")){

                    //   this.columns_officer_mobile_phone = false
                    // }

                    if (element == 'text_tel_detail') {
                        this.columns_officer_mobile_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_officer_mobile_phone = false;
                    }

                    // if (element == "update_date") {
                    //   this.columns_update_date = true
                    // }else if(!getData.includes("update_date")){

                    //   this.columns_update_date = false
                    // }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.button-container {
    display: flex;
    align-items: center;
}

.button-group {
    display: flex;
}
.table_row {
    text-align: center;
}

.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }

    .MP_courseOptions {
        width: 15.1rem;
        overflow-y: scroll;
    }
    .MP_courseOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .MP_courseOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .MP_courseOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
/* Doe UI Dropdown */
@media screen and (max-width: 430px) {
    .MP_course_name {
        width: 17.125rem;
        overflow-y: scroll;
    }
    .MP_course_name::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .MP_course_name::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    .MP_course_name::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    width: 234px;
    border: solid 1px #cccccc;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
// :deep(.p-dropdown) {
//     .p-dropdown-label{

//     font-family: "Sarabun","Helvetica", sans-serif ;
//   }

// }
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
.button-container {
    display: flex;
    justify-content: flex-end;
    width: 300px;
    margin-left: auto;
}

.button-right {
    width: 150px;
}

.input-group {
    display: flex;
    align-items: center;
}

.button-right-course {
    margin-left: 10px;
}

.topic-container {
    display: flex;
}

.full-width-input {
    width: 100%;
}
.fixed-width-button {
    width: 150px;
}

.fixed-width-input {
    width: calc(100% - 160px);
}

.v-data-table-header th {
    text-align: center;
    vertical-align: middle;
}

// .custom-table {
//     border-collapse: collapse;
//     width: 100%;
// }

.custom-table {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    visibility: visible;
    z-index: -999;
}
.custom-table-container {
    position: relative;
}

.custom-table th,
.custom-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.custom-table th {
    background-color: #f2f2f2;
    color: black;
    font-weight: bold;
}

.custom-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.custom-table tr:hover {
    background-color: #ddd;
}

.custom-table th,
.custom-table td {
    padding: 12px 15px;
}

.custom-table th {
    background-color: #4caf50;
    color: white;
}
</style>
